<template lang="html">
  <div
    class="tg_timegraph_container"
    :id="unique_identifier"
    :ref="unique_identifier"
  >
    <Modal v-if="save_graph_settings_as_modal" :title="$txt.graph_settings">
      <LabeledInput
        :label="$txt.name"
        v-model="save_graph_settings_as_name"
      />
      <br />
      <DropDown
        :title="$txt.graph_settings"
        v-model="selected_save_graph_settings_as"
        :opts="available_graph_settings_user"
        :disabled="false"
        @change="loadGraphPresets(true)"
      />
      <template v-slot:footer>
        <Btn
          v-if="$app.sltd.project.dto.canDelete"
          :title="$txt.delete_graph_setting"
          @clicked="
            delete_graph_setting(selected_save_graph_settings_as);
            "
          :disabled="(selected_save_graph_settings_as == null || selected_save_graph_settings_as > 900000)  ? true : null"
          style="float: left"
        />
        <Btn 
          :title="$txt.cancel" 
          class="hol_btn"
          @clicked="save_graph_settings_as_modal = false" 
          data-default-esc
        />
        <Btn
          :title="$txt.save_graph_settings"
          @clicked="save_graph_settings_as();
            save_graph_settings_as_modal = false;
            "
          :disabled="(save_graph_settings_as_name.length == 0)  ? true : null"
          data-default-enter
        />
      </template>
    </Modal>

    <Modal v-if="settings_modal" :title="$txt.graph_settings">
      <LabeledCheckbox
        :label="$txt.use_custom_size"
        v-model="use_custom_size"
      />
      <NumericInput
        :disabled="(!use_custom_size) ? true : null"
        :label="$txt.width_px"
        v-model="custom_width"
      />
      <NumericInput
        :disabled="(!use_custom_size) ? true : null"
        :label="$txt.height_px"
        v-model="custom_height"
      />

      <template v-slot:footer>
        <Btn
          :title="$txt.cancel"
          class="hol_btn"
          @clicked="settings_modal = false"
          data-default-esc
        />
        <Btn
          :title="$txt.submit"
          @clicked="
            settings_modal = false;
            resize();
            emitDiagramSettings();
          "
          data-default-enter
        />
      </template>
    </Modal>

    <Modal v-if="download_modal" :title="$txt.download_as_image">
      <DropDown
        :title="$txt.download_file_format"
        :tight="true"
        v-model="download_format"
        :opts="[{ id: 'png' }, { id: 'svg' }]"
      />
      <template v-slot:footer>
        <Btn
          :title="$txt.cancel"
          class="hol_btn"
          @clicked="download_modal = false"
          data-default-esc
        />
        <Btn
          :title="$txt.download"
          @clicked="download_modal = false; download_img();"
          data-default-enter
        />
      </template>
    </Modal>

    <Modal v-if="channel_serie_options_modal" :title="channel_serie_options.title">
      <LabeledInput 
        :label="$txt.y_axis_label" 
        v-model="channel_serie_options.yLabel" 
        :width="300"
      />
      <br />

      <LabeledCheckbox 
        :label="$txt.override_y_axis_scale" 
        v-model="channel_serie_options.override_y_axis_scale" 
      />
      <br />
      <NumericInput
        :label="$txt.y_axis_scale_min"
        v-model="channel_serie_options.override_y_axis_scale_min"
        :disabled = "(!channel_serie_options.override_y_axis_scale) ? true : null"
      />
      <NumericInput
        :label="$txt.y_axis_scale_max"
        v-model="channel_serie_options.override_y_axis_scale_max"      
        :disabled = "(!channel_serie_options.override_y_axis_scale) ? true : null"
      />
      <br /> 
      <LabeledCheckbox 
        :label="$txt.draw_line_at_0" 
        v-model="channel_serie_options.zero_line" 
      />
      <LabeledCheckbox 
        :label="$txt.draw_grid" 
        v-model="channel_serie_options.grid" 
      />
      <br />
      <LabeledCheckbox 
        :label="$txt.draw_line_at" 
        v-model="channel_serie_options.draw_line_at" 
      />
      <NumericInput
        label=""
        v-model="channel_serie_options.draw_line_at_value"
        style = "width:100px"
        :disabled = "(!channel_serie_options.draw_line_at) ? true : null"
      />
      <br />
      <EnumDropDown
        :title="$txt.graph_pos"
        :enum_to_choose_from="$enum.graph_pos"
        :disabled="false"
        v-model="channel_serie_options.yPos"
      />    
      <!-- <EnumDropDown
        :title="$txt.graph_type"
        :enum_to_choose_from="$enum.graph_type"
        :disabled="false"
        v-model="channel_serie_options.graph_type"
      />   -->
      <template v-slot:footer>
        <Btn
          :title="$txt.cancel"
          class="hol_btn"
          @clicked="channel_serie_options_modal = false" 
          data-default-esc
        />
        <Btn
          :title="$txt.submit"
          @clicked="
            channel_serie_options_modal = false;
            submit_channel_serie_options();
            resize();
          "
          data-default-enter
        />
      </template>
    </Modal>

    <Modal v-if="axis_options_modal" :title="axis_options.title">

      <LabeledInput 
        :label="$txt.y_axis_label" 
        v-model="axis_options.yLabel" 
        :width="300"
      />
      <br />

      <LabeledCheckbox 
        :label="$txt.override_y_axis_scale" 
        v-model="axis_options.override_y_axis_scale" 
      />
      <br />
       <NumericInput
        :label="$txt.y_axis_scale_min"
        v-model="axis_options.override_y_axis_scale_min"
        :disabled = "(!axis_options.override_y_axis_scale) ? true : null"
      />
      <NumericInput
        :label="$txt.y_axis_scale_max"
        v-model="axis_options.override_y_axis_scale_max"      
        :disabled = "(!axis_options.override_y_axis_scale) ? true : null"
      />
      <br />

      <LabeledCheckbox 
        :label="$txt.draw_line_at_0" 
        v-model="axis_options.zero_line" 
      />
      <LabeledCheckbox 
        :label="$txt.draw_grid" 
        v-model="axis_options.grid" 
      />
      <LabeledCheckbox 
        :label="$txt.draw_line_at" 
        v-model="axis_options.draw_line_at" 
      />
      <NumericInput
        label=""
        v-model="axis_options.draw_line_at_value"
        style = "width:100px"
        :disabled="(!axis_options.draw_line_at_value) ? true : null"
      />
      <br />
      <LabeledInput 
        :label="$txt.graph_description" 
        v-model="new_graph_description" 
        :width="300"
      />
    
      <template v-slot:footer>
        <Btn 
          :title="$txt.cancel" 
          class="hol_btn"
          @clicked="axis_options_modal = false"
          data-default-esc
        />
        <Btn
          :title="$txt.submit"
          @clicked="
            axis_options_modal = false;
            submit_axis_options();
            resize();
          "
          data-default-enter
        />
      </template>
    </Modal>

    <Modal v-if="graph_description_modal" :title="$txt.graph_settings">

      <LabeledInput 
        :label="$txt.graph_description" 
        v-model="new_graph_description" 
        :width="300"
      />
    
      <template v-slot:footer>
        <Btn 
          :title="$txt.cancel" 
          class="hol_btn"
          @clicked="graph_description_modal = false" 
          data-default-esc
        />

        <Btn
          :title="$txt.submit"
          @clicked="
            axis_options_modal = false;
            submit_graph_description();
            resize();
          "
          data-default-enter
        />
        
      </template>
    </Modal>

    <CompactPanel>
      <div class="tg_toolbar">
        <div class="tg_toolbar_group">
          <span class="tg_toolbar_check">
            <CheckBox
              v-model="show_channel_control_panel"
              :title="$txt.hint_show_channel_control_panel"
              @input="emitDiagramSettings"
            />
            {{ $txt.show_channel_controls }}
          </span>
          <span class="tg_toolbar_check">
            <CheckBox
              v-model="show_legend"
              :title="$txt.hint_show_legend"
              @input="emitDiagramSettings"
            />
            {{ $txt.show_legend }}
          </span>
          <span class="tg_toolbar_check" v-if="has_hold_values">
            <CheckBox
              @click="show_hold_values_in_graph()"
              v-model="showHoldValues"
            />
            {{ $txt.show_hold_values }}
          </span>
          <Btn
            v-if="has_hold_values"
            :title="$txt.hold_values"
            @clicked="hold_values(), save_hold_values_to_localStorage()"
          />
          <Btn
            v-if="has_fill_channels"
            :title="fill_channels_title"
            @clicked="fill_channels()"
          />
        </div>

        <div class="tg_toolbar_group tg_toolbar_right">
          <Btn
            :title="openGraphSettings ? 'Graph settings ⇆' : 'Graph settings ⇄'"
            :class="{ active: openGraphSettings }"
            class="sidepanelbtn"
            @clicked="open_graph_settings()"
          />
          <Btn
            v-if="diagram"
            :title="'reload report settings'"
            class="hol_btn"
            @clicked="reload_stored_settings();"
          />
          <Btn
            :title="$txt.reset_graph_settings"
            class="hol_btn"
            @clicked="reset_graph_settings(true, true)"
          />
          <Btn
            v-if="$app.sltd.project.dto.canSetup"
            :title="$txt.save_graph_settings_as"
            class="hol_btn"
            @clicked="prepare_to_save_graph_settings_as()"
          />
          <Btn
            v-if="$app.sltd.project.dto.canSetup"
            :title="selected_graph_setting == 999996 ? 'Save to default' : $txt.save_graph_settings"
            class="hol_btn"
            @clicked="selected_graph_setting == 999996 ? save_formula_defaults() : save_graph_settings()"
            :disabled="(!any_graph_setting_selected || (preset_is_selected && selected_graph_setting != 999996) || (selected_graph_setting == 999996 && !formulaDefaultsChanged)) ? true : null"
          />
          <DropDown
            title=""
            v-model="selected_graph_setting"
            :opts="available_graph_settings"
            :disabled="false"
            @change="disable_settings_loaded_from_report(), loadGraphPresets(true)"
            @input="loadGraphPresets(true)"
          />
          <span
            v-if="available_graph_settings.length > 1"
            class="tg_preset_count_badge"
          >+{{ available_graph_settings.length - 1 }}</span>
        </div>
      </div>
    </CompactPanel>
    <div
      class="tg_channel_selector"
      v-if="show_channel_control_panel"
      :style="{ width: (width + 70) + 'px' }"
      @wheel.stop
    >
      <div class="tg_cs_header">
        <p class="wm_control_label">{{ $txt.channels }}</p>
        <label class="tg_cs_all">
          <input
            class="wm_checkbox"
            type="checkbox"
            :checked="graph_buffer ? graph_buffer.hidden_series.length == 0 : false"
            v-on:input="select_deselect_all()"
            @input="emitDiagramSettings"
            title="Hide/Show all channels in graph"
          />
          {{ select_deselect_message }}
        </label>
      </div>

      <div class="tg_cs_sections">
        <div
          class="tg_cs_section"
          v-for="section in channel_group_sections"
          :key="section.key"
        >
        <div class="tg_cs_section_title" v-if="section.title">
          <input
            class="wm_checkbox"
            type="checkbox"
            :checked="is_section_all_shown(section)"
            v-on:input="toggle_section(section)"
            :title="'Show/hide all ' + section.title + ' channels'"
          />
          {{ section.title }}
        </div>
          <div class="tg_cs_columns">
            <div
              class="tg_cs_group"
              v-for="group in section.groups"
              :key="group.key"
            >
              <table class="wm_table tg_cs_table">
                <thead>
                  <tr>
                    <th class="tg_cs_col_check">
                      <input
                        class="wm_checkbox"
                        type="checkbox"
                        :checked="is_group_all_shown(group)"
                        v-on:input="toggle_group(group)"
                        :title="'Show/hide all ' + group.label"
                      />
                    </th>
                    <th class="tg_cs_col_name">{{ group.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="s in group.series" :key="s.id">
                    <td class="tg_cs_col_check">
                      <input
                        class="wm_checkbox"
                        type="checkbox"
                        v-on:input="toggle_hidden(s), emitDiagramSettings();"
                        :checked="!is_hidden(s)"
                        :title="$txt.hint_show_channel_in_graph"
                      />
                    </td>
                    <td class="tg_cs_col_name">
                      <a
                        class="wm_icon_btn"
                        :title="$txt.open_settings_for_serie"
                        @click="show_channel_serie_options(s)"
                        :style="{ color: 'gray' }"
                      >
                        <svg-icon size="16" viewbox="0 0 18 18" :path="settingsIcon" />
                      </a>
                      <span
                        class="wm_table_colored_box"
                        draggable="true"
                        @dragstart="startDrag($event, s)"
                        @dragend="endDrag()"
                        :style="{ backgroundColor: s.color, cursor: 'grab' }"
                        :title="$txt.hint_channel_name"
                      >
                        {{ s.name }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tg_timegraph_holder" :id = "unique_identifier+'my_timegraph'" ref="my_timegraph">
      <div
        class="tg_select_channel_column"
        id="my_channel_column"
        v-if="false"
        :style="{
          width: dynamicChannelPanelWidth,
          maxHeight: height + 'px',
          overflowY: 'auto'
        }"
        @wheel.stop
      >
        <p class="wm_control_label">{{ $txt.channels }}</p>
        <table>
          <tbody>
            <tr>
              <td style="width: 20px">
                <input
                  class="wm_checkbox"
                  type="checkbox"
                  :checked="this.graph_buffer ? this.graph_buffer.hidden_series.length == 0 : false"
                  v-on:input="select_deselect_all()"
                  @input="emitDiagramSettings"
                  title="Hide/Show all channels in graph"
                  />
              </td>
              <td>
                {{ select_deselect_message }}
              </td>
              <td>
                <span v-if="showHoldValues">
                  {{ $txt.held_values }}
                </span>
              </td>
            </tr>
            <div v-if="showHoldValues">
              <tr v-for="s in channel_series" :key="s.id" >
                <td>
                  <input
                    class="wm_checkbox"
                    type="checkbox"
                    v-on:input="toggle_hidden(s)"
                    :checked="!is_hidden(s)"
                    :title="$txt.hint_show_channel_in_graph"
                  />
                  <a
                    class="wm_icon_btn"
                    :title="$txt.open_settings_for_serie"
                    @click="show_channel_serie_options(s)"
                    :style="{color:'gray'}"
                  >
                    <svg-icon size="16" viewbox="0 0 18 18" :path="settingsIcon" />
                  </a> 
                  <!--<IconBtn
                    size="15"
                    :icon="$icon.graph_settings"
                    :tooltip="$txt.open_settings_for_serie"
                    @click="show_channel_serie_options(s)"
                  /> -->
                  <span 
                    class="wm_table_colored_box"
                    draggable="true"
                    @dragstart="startDrag($event, s)"
                    @dragend="endDrag()"
                    :style="{
                    backgroundColor: s.color
                    }"
                    
                  >
                    {{s.name}}
                  </span>
                </td>
                <td style="text-align: right" id="my_held_values">
                  <span v-if="showHoldValues">
                    {{ s.hold_value }}
                  </span>  
                </td>
                <td style="text-align: right">
                  <span v-if="highlighted_samples[s.id] != null">
                    <span
                      v-if="highlighted_samples[s.id].hasOwnProperty('value')"
                    >
                      <span
                        v-if="isFiniteNum(highlighted_samples[s.id].value)"
                      >
                        {{ fmt(highlighted_samples[s.id].value, s.decimals) }}
                        {{ s.unit }}
                      </span>
                    </span>
                    <span v-else>
                      <span
                        v-if="isFiniteNum(highlighted_samples[s.id].minVal)"
                      >
                        {{ fmt(highlighted_samples[s.id].minVal, s.decimals) }}
                        <span
                          v-if="
                            fmt(highlighted_samples[s.id].minVal, s.decimals) !=
                              fmt(highlighted_samples[s.id].maxVal, s.decimals)
                          "
                        >
                          -
                          {{ fmt(highlighted_samples[s.id].maxVal, s.decimals) }}
                        </span>
                        {{ s.unit }}
                      </span>
                    </span>
                  </span>
                </td>
              </tr>
            </div>
            <div v-if="!showHoldValues">
              <tr v-for="s in channel_series" :key="s.id">
                <td style="width: 90px">
                  <input
                    class="wm_checkbox"
                    type="checkbox"
                    v-on:input="toggle_hidden(s), emitDiagramSettings();"
                    :checked="!is_hidden(s)"
                    :title="$txt.hint_show_channel_in_graph"
                  />

                  <!--<IconBtn
                    size="15"
                    :icon="$icon.graph_settings"
                    :tooltip="$txt.open_settings_for_serie"
                    @click="show_channel_serie_options(s)"
                  /> -->
                  <a
                    class="wm_icon_btn"
                    :title="$txt.open_settings_for_serie"
                    @click="show_channel_serie_options(s)"
                    :style="{color:'gray'}"
                  >
                    <svg-icon size="16" viewbox="0 0 18 18" :path="settingsIcon" />
                  </a> 
                  <span 
                    class="wm_table_colored_box"
                    draggable="true"
                    @dragstart="startDrag($event, s)"
                    @dragend="endDrag()"
                    :style="{
                    backgroundColor: s.color,cursor: 'grab'
                    }"
                    :width="150"
                    :title="$txt.hint_channel_name"
                  >
                    {{s.name}}
                  </span>
                </td>
                <td style="width: 90px; text-align: right">
                  <span v-if="highlighted_samples[s.id]">
                    <template v-if="'value' in highlighted_samples[s.id]">
                      {{ fmt(highlighted_samples[s.id].value, s.decimals) }}
                    </template>
                    <template v-else>
                      <span v-if="isFiniteNum(highlighted_samples[s.id].minVal)">
                        {{ fmt(highlighted_samples[s.id].minVal, s.decimals) }}
                        <span v-if="fmt(highlighted_samples[s.id].minVal, s.decimals) !== fmt(highlighted_samples[s.id].maxVal, s.decimals)">
                          - {{ fmt(highlighted_samples[s.id].maxVal, s.decimals) }}
                        </span>
                      </span>
                    </template>
                    {{ s.unit }}
                  </span>
                </td>
              </tr>
            </div>
          </tbody>
        </table>
      </div>
       <div class="tg_timegraph" 
            @drop="onDrop($event, 1)"
            @dragover.prevent
            @dragenter.prevent
            style="overflow:visible">
        
        <div style="position:relative">
          <div
            class="wm_overlay_icon"
            :style="{
              top: height / 2 - 25 + 'px',
              left: width / 2 - 60 + 'px'
            }"
            v-if="loading_data"
          >
            <SmallIcon
              class="r rotating"
              icon="cached"
              size="30"
              color="rgba(0,0,0,0.3)"
            />
            <p class="no_data_text text_shadow">
              {{ $txt.loading }} {{ loading_progress }}
            </p>
          </div>
          <div
            class="wm_overlay_icon"
            v-if="channel_series.length == 0 && !loading_data"
            :style="{
              top: height / 2 - 25 + 'px',
              left: width / 2 - 60 + 'px'
            }"
          >
            <span class="no_data_text">{{ $txt.no_data }}</span>
          </div>
        </div>

        <svg :id="canvas_id" ref="abc" :height="height" :width="width">
          <defs>
            <clipPath :id="unique_identifier+'clipPath'">
              <rect :id="unique_identifier+'tg_clipping_rect'" x="15" y="15" width="0" height="0" />
            </clipPath>
          </defs>

          <g class="tg_axis"></g>
          <g class="tg_axis_grid"></g>
          <g class="tg_left_axis"></g>

          <line
            id="tg_vertical_line"
            class="tg_vertical_line tg_only_on_hover"
            :style="{ clipPath: `url(#${unique_identifier}clipPath)` }"
          >
            Tooltip
          </line>

          <path class="tg_path"></path>

          <line id="tg_zero_line"></line>
          <line id="tg_value_line"></line>
          <line id="tg_alarm_low_line" class="tg_alarm_lines"></line>
          <line id="tg_alarm_high_line" class="tg_alarm_lines"></line>
          <g
            class="tg_focus_circles tg_only_on_hover"
            :style="{ clipPath: `url(#${unique_identifier}clipPath)` }"
          ></g>
          <rect
            id="tg_tooltip"
            class="tg_tooltip tg_only_on_hover"
            width="88"
            height="20"
            style="display: none;"
          ></rect>
          <text
            y="20"
            x="50"
            class="tg_only_on_hover"
            id="tg_tooltip_text"
            fill="black"
            style="display: none;"
          >
            -
          </text>
          <text
            y="20"
            x="50"
            class="tg_only_on_hover"
            id="tg_date_display"
            fill="black"
          ></text>
          <text
            y="36"
            x="50"
            class="tg_only_on_hover"
            id="tg_recording_display"
            fill="black"
            style="font-size: 12px;"
          ></text>
          <rect id="tg_magnify_rect"></rect>
          <g class="tg_series_container" :style="{ clipPath: `url(#${unique_identifier}clipPath)` }"></g>
          <rect
            class="tg_overlay"
            fill="rgba(0,0,0,0)"
            @mousemove="mousedrag"
            @mousedown="mousedown"
          ></rect>
        </svg>
        <!-- Shown when the parent passes overview_series (OVERVIEW_ENABLED in the report tabs).
             TODO: make optional in graph settings. -->
        <TimeGraphOverview
          v-if="show_overview"
          :series="overview_series"
          :hidden_series="graph_buffer?.hidden_series ?? []"
          :recordings="graph_buffer?.recordings ?? []"
          :data_version="overview_version"
          :from="overview_range.from"
          :to="overview_range.to"
          :view_from="displayedDates?.minDate ?? null"
          :view_to="displayedDates?.maxDate ?? null"
          :width="overview_frame.width"
          :x0="overview_frame.x0"
          :x1="overview_frame.x1"
          :height="OVERVIEW_HEIGHT"
          :show_legend="show_legend"
          :style="{ marginTop: OVERVIEW_GAP + 'px' }"
          @pan="pan_to_center"
          @zoom="set_view_range"
        />

        <div
          class="tg_actions_bar"
          :style="{ 'padding-left': this.paddingXLeft + 'px' }"
        >
          <IconBtn
            :icon="$icon.graph_settings"
            :tooltip="$txt.open_settings_for_graph"
            @clicked="settings_modal = true"
          />
          <IconBtn
            :icon="$icon.download_graph_img"
            :tooltip="$txt.download_as_image"
            @clicked="download_modal = true"
          />
          <IconBtn
            v-show="!magnify_mode && !disable_zoom"
            :icon="$icon.zoom_area"
            :tooltip="$txt.zoom_to_area"
            @clicked="magnify_mode = true"
          />
          <IconBtn
            v-show="interval_scaling_factor != natural_scaling_factor || offset_ms != natural_offset_ms || magnify_mode || y_axis_is_zoomed"
            :icon="$icon.clear_zoom_and_offset"
            :tooltip="$txt.reset_zoom_and_movement"
            @clicked="
              reset_zoom_to_natural();
              on_displayed_area_changed(true);
              magnify_mode = false;
              magnify_start_position = null;
              resize();
            "
          />
        </div>
      </div>

      <div
        v-if="hovered_channels.length"
        ref="hover_tooltip"
        class="tg_hover_tooltip"
        :style="hover_tooltip_style"
      >
        <div v-if="hover_meta" class="tg_ht_header">
          <div class="tg_ht_time">{{ hover_meta.time }}</div>
          <div v-if="hover_meta.recording" class="tg_ht_rec">{{ hover_meta.recording }}</div>
        </div>
        <div class="tg_ht_group" v-for="g in hovered_channel_groups" :key="g.key">
          <div class="tg_ht_group_title">{{ g.label }}</div>
          <div class="tg_ht_row" v-for="c in g.rows" :key="c.id">
            <span class="tg_ht_dot" :style="{ backgroundColor: c.color }"></span>
            <span class="tg_ht_name">{{ c.name }}</span>
            <span class="tg_ht_val">{{ c.value }}</span>
          </div>
        </div>
      </div>

      <!-- Graph Settings Side Panel -->
      <transition name="tg_gsp_slide">
        <div
          v-if="openGraphSettings"
          class="tg_graph_settings_panel"
          :style="{ width: graphSettingsPanelWidth + 'px' }"
        >
          <div class="tg_gsp_drag_handle" @mousedown.prevent="startDragSettingsPanel" />
          <div class="tg_gsp_header">
            <span>Graph settings</span>
            <a class="wm_icon_btn" @click="openGraphSettings = false" title="Close" style="cursor:pointer;font-size:16px;line-height:1">✕</a>
          </div>
          <div class="tg_gsp_content">
            <Section
              v-for="axis in panelAxes"
              :key="axis.unit"
              :title="axis.unit"
            >
              <LabeledCheckbox
                :label="'Include channels on axis'"
                :model-value="isAxisVisible(axis.unit)"
                @change="toggleAxisChannels(axis.unit)"
              />
              <br/>
              <LabeledInput
                :label="'Label'"
                v-model="axis.yLabel"
                :width="180"
                @change="applyAxisSettingsFromPanel(axis.unit, axis)"
              />
              <br />
              <template v-if="selected_graph_setting != 999996">
                <LabeledCheckbox
                  :label="$txt.override_y_axis_scale"
                  v-model="axis.override_y_axis_scale"
                  @change="applyAxisSettingsFromPanel(axis.unit, axis)"
                />
                <br />
                <NumericInput
                  :label="'Min'"
                  v-model="axis.override_y_axis_scale_min"
                  :disabled="(!axis.override_y_axis_scale) ? true : null"
                  @change="applyAxisSettingsFromPanel(axis.unit, axis)"
                />
                <NumericInput
                  :label="'Max'"
                  v-model="axis.override_y_axis_scale_max"
                  :disabled="(!axis.override_y_axis_scale) ? true : null"
                  @change="applyAxisSettingsFromPanel(axis.unit, axis)"
                />
              </template>
              <template v-else>
                <NumericInput
                  :label="'Min'"
                  v-model="axis.graph_min"
                  @change="applyAxisSettingsFromPanel(axis.unit, axis)"
                />
                <NumericInput
                  :label="'Max'"
                  v-model="axis.graph_max"
                  @change="applyAxisSettingsFromPanel(axis.unit, axis)"
                />
              </template>
              <br />
              <!-- <LabeledCheckbox
                :label="$txt.draw_line_at_0"
                v-model="axis.zero_line"
                @change="applyAxisSettingsFromPanel(axis.unit, axis)"
              /> -->
              <LabeledCheckbox
                :label="$txt.draw_grid"
                v-model="axis.grid"
                @change="applyAxisSettingsFromPanel(axis.unit, axis)"
              />
              <br />
              <LabeledCheckbox
                :label="'Draw line at'"
                v-model="axis.draw_line_at"
                @change="applyAxisSettingsFromPanel(axis.unit, axis)"
              />
              <NumericInput
                label=""
                v-model="axis.draw_line_at_value"
                style="width:100px"
                :disabled="(!axis.draw_line_at) ? true : null"
                @change="applyAxisSettingsFromPanel(axis.unit, axis)"
              />
              <br />
              <EnumDropDown
                :title="$txt.graph_pos"
                :enum_to_choose_from="$enum.graph_pos"
                :disabled="false"
                v-model="axis.yPos"
                @update:modelValue="applyAxisSettingsFromPanel(axis.unit, axis)"
              />
            </Section>
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import { render_graph, init_graph, stacked_graph_positions } from "@/recordings/graphrender";
import globalSettings from "@/globalsettings.js";
const Enum = require("@/utils/enums").default;
const settingsIcon="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34a.4.4 0 00-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z";
const Camur = require('@/utils/camurutils').default;
const OVERVIEW_HEIGHT = 72;
const OVERVIEW_GAP = 4;

export default {
  setup() {
    return {
      settingsIcon,
      OVERVIEW_HEIGHT,
      OVERVIEW_GAP
    }
  },
  name: "TimeGraph",
  data() {
    return {
      isPanning: false,
      axisDrag: null,
      reloadingReportSettingsBool: false,
      resetDiagramSettingsBool: false,
      blockWatcherEmits: false,
      hasDoneInitialLoad: false,
      settings_loaded_from_report: false,
      width: 1,
      height: 1,
      settings_modal: false,
      download_modal: false,
      use_custom_size: false,
      download_format: "svg",
      custom_width: 1200,
      custom_height: 500,
      wait_before_load: 100,
      offset_ms: (this.diagram?.xAxisOffset && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1) ? this.diagram.xAxisOffset : 0,
      offset_ms_before_pan: 0,
      interval_scaling_factor: (this.diagram?.xAxisZoom && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1) ? this.diagram.xAxisZoom : 1,
      // "Natural" reference for the reset-zoom button. Defaults to the full
      // interval (1 / 0). When the host applies a context-changing zoom via
      // requested_zoom_interval (e.g. zoom_to_recording on selecting a recording,
      // zoom_to_report_dates on deselect), the watcher captures the resulting
      // scaling/offset here. The reset-zoom button only highlights when the
      // current view differs from this reference, and clicking it restores to
      // this reference — so selecting a recording isn't itself treated as a zoom.
      natural_scaling_factor: 1,
      natural_offset_ms: 0,
      pan_start_x_pos: 0,
      magnify_start_position: null,
      magnify_mode: false,
      display_area_change_tstamp: null,
      displayedDates: null,
      overview_frame: null,
      highlighted_samples: {},
      hover_meta: null,
      tooltip_width: 0,
      applying_preset: false,
      has_persisted_channels: false,
      persisted_hidden: [],
      last_length: 0,
      last_mouse_client_x: null,
      last_mouse_client_y: null,
      tick: null,
      raf_id: null,
      pan_start_y_pos: 0,
      offset_y_before_pan: 0,
      axesData: {
          selectedIndex: -1,
          selectedX: false,
          transpose:null,
          array: null
      },
      channel_series: [],
      channel_serie: null,
      channel_serie_options: {
          title: "",
          yLabel: "",
          override_y_axis_scale: false,
          override_y_axis_scale_min: 0,
          override_y_axis_scale_max: 0,
          grid: false,
          zero_line: false,
          draw_line_at: false,
          draw_line_at_value : 100,
          graph_type: this.$enum.graph_type.graph_type_line
      },
      channel_serie_options_modal: false,
      axis_options: {
          title: "",
          unitLabel: "",
          yLabel: "",
          override_y_axis_scale: false,
          override_y_axis_scale_min: 0,
          override_y_axis_scale_max: 200,
          grid: false,
          zero_line: false,
          draw_line_at: false,
          draw_line_at_value : 100
      },
      axis_options_modal: false,
      new_graph_description: "",
      graph_description: "Test",
      graph_description_modal: false,
      selected_graph_setting: null,
      show_legend: this.diagram ? true : this.$appm.restore('graphSettingsPanel.show_legend', false),
      show_channel_control_panel: this.diagram ? false : this.$appm.restore('graphSettingsPanel.show_channel_control_panel', true),
      save_graph_settings_as_modal: false,
      selected_save_graph_settings_as:null,
      save_graph_settings_as_name:"",
      localStorageId:"",
      dragChannel:false,
      showHoldValues: false,
      preset_is_selected: false,
      openGraphSettings: this.diagram
        ? (this.graph_settings_open ?? !this.diagram)
        : this.$appm.restore('graphSettingsPanel.open', this.graph_settings_open ?? true),
      graphSettingsPanelWidth: 400,
      isDraggingSettingsPanel: false,
      dragSettingsPanelStartX: 0,
      dragSettingsPanelStartWidth: 0,
      prev_hidden_series: [],
    };
  },
  mounted() {
    this.select_nodes();
    this.$refs.my_timegraph.addEventListener("wheel", this.handle_scroll, {
      capture: false,
      passive: false
    });
    window.addEventListener("resize", this.on_window_resize);
    window.addEventListener("wm-layout-changed", this.resize);
    this.graph_description = this.default_graph_description;
    if (this.diagram) {
      this.localStorageId = this.unique_identifier; 
    } else {
      this.localStorageId = this.local_storage_id;
    }
    if (!this.diagram) {
      let selectedGraphSettingName = localStorage.getItem("GlobalGraphPreset");
      if (selectedGraphSettingName != null && selectedGraphSettingName !== "") {
          let asNumber = Number(selectedGraphSettingName);
          if (!isNaN(asNumber) && asNumber > 0) {
            this.selected_graph_setting = asNumber;
          } else {
            this.selected_graph_setting = this.settingIdOf(selectedGraphSettingName);
          }
      } else if (this.has_operating_data_nodes()) {
          this.selected_graph_setting = 999998;
      }
      let sizeJson = localStorage.getItem('timegraph_custom_size');
      if (sizeJson != null) {
        try {
          let s = JSON.parse(sizeJson);
          this.use_custom_size = s.use_custom_size ?? false;
          this.custom_width = s.custom_width ?? 1000;
          this.custom_height = s.custom_height ?? 800;
        } catch (e) {}
      }
      let hiddenJson = localStorage.getItem("C3_TG_hidden_" + this.localStorageId);
      if (hiddenJson != null) {
        try {
          let arr = JSON.parse(hiddenJson);
          if (Array.isArray(arr)) {
            this.persisted_hidden = arr;
            this.has_persisted_channels = true;
            this.$emit("set-hidden-series", arr);
          }
        } catch (e) {}
      }
    }
    if (this.selected_graph_setting_prop && !this.selected_graph_setting) {
      this.selected_graph_setting = this.selected_graph_setting_prop;
    }
    this.tick = window.setInterval(this.on_graph_update_tick, 200, this);
    if (this.selected_graph_setting == 0) {
      this.selected_graph_setting = 999996;
    }
    if (this.diagram?.yAxisZoom && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1) {
      this.axesData.transpose = JSON.parse(JSON.stringify(this.diagram.yAxisZoom));
    }
    if (this.diagram?.xAxisZoom && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1) {
      this.interval_scaling_factor = this.diagram.xAxisZoom;
    } else {
      this.interval_scaling_factor = 1;
    }
    if (this.diagram?.xAxisOffset && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1) {
      this.offset_ms = this.diagram.xAxisOffset;
    } else {
      this.offset_ms = 0;
      init_graph(this.canvas_id, this.height, this.width);
      this.load_graph_settings_from_saved_report_diagram();
    }
    this.resize();
    window.addEventListener("mouseup", this.mouseUp);
  },
  unmounted() {
    window.clearInterval(this.tick);
    window.removeEventListener("resize", this.on_window_resize);
    window.removeEventListener("wm-layout-changed", this.resize);
    window.removeEventListener("wheel", this.handle_scroll);
    window.removeEventListener("mouseup", this.mouseUp);
    if (this._wheel_raf != null) {
      cancelAnimationFrame(this._wheel_raf);
      this._wheel_raf = null;
    }
  },
  methods: {
    open_graph_settings() {
      this.openGraphSettings = !this.openGraphSettings;
    },
    startDragSettingsPanel(e) {
      this.isDraggingSettingsPanel = true;
      this.dragSettingsPanelStartX = e.clientX;
      this.dragSettingsPanelStartWidth = this.graphSettingsPanelWidth;
      document.addEventListener('mousemove', this.onDragSettingsPanel);
      document.addEventListener('mouseup', this.stopDragSettingsPanel);
    },
    onDragSettingsPanel(e) {
      if (!this.isDraggingSettingsPanel) return;
      const dx = e.clientX - this.dragSettingsPanelStartX;
      this.graphSettingsPanelWidth = Math.max(150, Math.min(700, this.dragSettingsPanelStartWidth - dx));
    },
    stopDragSettingsPanel() {
      this.isDraggingSettingsPanel = false;
      document.removeEventListener('mousemove', this.onDragSettingsPanel);
      document.removeEventListener('mouseup', this.stopDragSettingsPanel);
    },
    isFiniteNum(v) {
      if (v == null) return false;
      const n = Number(v);
      return Number.isFinite(n);
    },
    fmt(v, d=0) {
      const n = Number(v);
      if (!Number.isFinite(n)) return n === Infinity ? '∞' : n === -Infinity ? '-∞' : 'NaN';
      return n.toFixed(d).replace(".", this.$app.settings.decimal_point);
    },
    emitDiagramSettings() {
      // Only diagrams (report context) listen to this event. Skipping in zone/live
      // context avoids the per-wheel-tick settings_object() rebuild during scroll-zoom.
      if (!this.diagram) return;
      const diagramSettings = {
        selected_graph_setting: this.selected_graph_setting,
        settings: this.settings_object(),
        yAxisZoom: this.axesData.transpose,
        xAxisZoom: this.interval_scaling_factor,
        xAxisOffset: this.offset_ms
      };
      this.$emit('diagram-settings-updated', diagramSettings);
    },
    show_hold_values_in_graph() {
      let channelColumn = document.getElementById("my_channel_column");
      if (channelColumn) {
        channelColumn.style.width = this.showHoldValues ? "400px":"550px";
      }
    },
    save_hold_values_to_localStorage() {
      for (let node of this.$app.sltd.project.all_nodes) {
        localStorage["C3_Hold_"+node.cross_prj_identifier] = JSON.stringify(
          node.app_prop.held_vals
        );
      }
    },
    hold_values() {
        // console.log("TimeGraph.hold_values hold");
        for (let node of this.nodes) {
          node.hold_values();
        }
    },
    fill_channels() {
      // console.log("TimeGraph.fill_channels");
      this.$emit("fill_channels");
    },
    clear_channels() {
      // console.log("TimeGraph.clear_channels_channels");
      this.$emit("clear_channels");
    },
    select_nodes() {
      // console.log("TimeGraph.select_nodes");
      this.$ui.project_tree_keep_open = true;
      this.$emit("select_nodes");
    },
    done_select_nodes() {
      // console.log("TimeGraph.done_select_nodes");
      this.$emit("done_select_nodes");
    },
    on_graph_update_tick() {

      if (this.autoshift) {
        if (this.channel_series.length != this.last_length) {
          this.last_length = this.channel_series.length;
          const savedSetting = this.selected_graph_setting;
          this.reset_graph_settings(true, false);
          // reset_graph_settings forces selected_graph_setting = 999996. If the user had a
          // different preset active, restore it synchronously before the RAF fires.
          // Vue coalesces the 999996→savedSetting change back to a net-zero watcher trigger
          // so localStorage keeps the correct value and the RAF renders with the right preset.
          if (savedSetting && this.selected_graph_setting != savedSetting) {
            this.selected_graph_setting = savedSetting;
            this.loadGraphPresets(true);
          }
        } else {
          this.resize();
        }
      }
    },
    zoomYAxis(deltaY) {
      const i = this.axesData.selectedIndex;
      if (i < 0) return false;

      const t = this.axesData.transpose[i];
      const a = this.axesData.array[i];
      if (!t || !a) return false;

      // A wheel notch is a constant ratio rather than a constant step, which keeps
      // the deep end of the range reachable and makes zooming in and out cost the
      // same effort. The rate is picked so one 100px notch is about 20%, matching
      // the feel at factor 1. Summing deltas per animation frame stays exact,
      // since exp(-K*(d1+d2)) == exp(-K*d1) * exp(-K*d2).
      const ZOOM_RATE = 0.0018;
      // The factor divides the visible range, so 500 is 500x in and 1/500 is 500x out.
      // ZOOM_MIN is derived rather than written out, so the two ends cannot drift apart.
      const ZOOM_MAX = 500;
      const ZOOM_MIN = 1 / ZOOM_MAX;

      const previous_zoom = t.zoomFactor > 0 ? t.zoomFactor : 1;
      let zoom = previous_zoom * Math.exp(-ZOOM_RATE * deltaY);
      if (zoom < ZOOM_MIN) zoom = ZOOM_MIN;
      if (zoom > ZOOM_MAX) zoom = ZOOM_MAX;
      t.zoomFactor = zoom;

      // The zoom is anchored at the cursor: the value under the pointer stays put,
      // which requires the pan offset to follow the zoom. Leaving the offset alone
      // lets the visible window drift towards the axis mid-point as you zoom in,
      // since the offset is measured against the visible (shrinking) range.
      const axis_height = a.rangeMin - a.rangeMax;
      if (axis_height > 0 && previous_zoom > 0 && zoom > 0) {
        const anchor = this.y_zoom_anchor_fraction(a, axis_height);
        const offset_fraction = t.offset / axis_height;
        t.offset = ((zoom / previous_zoom) * (offset_fraction + anchor - 0.5)
                    + 0.5 - anchor) * axis_height;
      }

      t.unit = a.unit;
      t.gi = a.gi;
      return true;
    },
    // Cursor position on the axis as a fraction of its height, measured from the
    // bottom edge. Falls back to the axis mid-point (which keeps the centre of the
    // visible range fixed) when the pointer is unknown or outside the axis — an
    // axis can also be selected by clicking a channel name, with the pointer
    // nowhere near it.
    y_zoom_anchor_fraction(axis, axis_height) {
      const svg = this.$refs.abc;
      const client_y = this._wheel_client_y;
      if (!svg || client_y == null) return 0.5;
      const local_y = client_y - svg.getBoundingClientRect().top;
      const fraction = (axis.rangeMin - local_y) / axis_height;
      if (fraction < 0 || fraction > 1) return 0.5;
      return fraction;
    },
    zoomXAxis(deltaY) {
      // Constant-ratio steps, as on the y axis, at the rate the previous linear
      // update gave near scale 1. MIN_SCALE sits above zero so a fast wheel fling
      // cannot collapse the window to zero width.
      const ZOOM_RATE = 0.0002;
      const MAX_SCALE = 500;
      const MIN_SCALE = 0.000001;

      const previous_scale = this.interval_scaling_factor > 0 ? this.interval_scaling_factor : 1;
      let scale = previous_scale * Math.exp(ZOOM_RATE * deltaY);
      if (scale > MAX_SCALE) scale = MAX_SCALE;
      if (scale < MIN_SCALE) scale = MIN_SCALE;
      this.interval_scaling_factor = scale;

      // Anchor at the cursor. The window spans position ± base_interval*scale/2,
      // shifted by offset_ms, so keeping the time under the pointer fixed means
      // moving the offset by the change in half-width, weighted by how far the
      // pointer sits from the middle. autoshift slides the window but keeps its
      // duration, so the base interval is the same in both cases.
      const base_interval = this.end_date - this.start_date;
      if (base_interval > 0) {
        const anchor = this.x_zoom_anchor_fraction();
        this.offset_ms += base_interval * (previous_scale - scale) * (anchor - 0.5);
      }
    },

    x_zoom_anchor_fraction() {
      const svg = this.$refs.abc;
      const client_x = this._wheel_client_x;
      const range = this.axesData.xRange;
      if (!svg || client_x == null || !range || range[1] <= range[0]) return 0.5;
      const local_x = client_x - svg.getBoundingClientRect().left;
      const fraction = (local_x - range[0]) / (range[1] - range[0]);
      if (fraction < 0 || fraction > 1) return 0.5;
      return fraction;
    },
    select_deselect_all() {
      if (this.graph_buffer.hidden_series.length === 0) {
      // Emit an event to hide all series
      this.$emit('select-deselect-all-series', false);
      } else {
      // Emit an event to show all series
      this.$emit('select-deselect-all-series', true);
      }
      this.persist_channel_selection();
      this.resize();
    },
    persist_channel_selection() {
      if (this.diagram != null || this.applying_preset) return;
      this.persisted_hidden = [...this.graph_buffer.hidden_series];
      this.has_persisted_channels = true;
      this.save_hidden_series_to_localStorage();
    },
    available_graph_height() {
      if (this.report_type == 7 || this.autoshift) {
        return this.fixed_height || 500;
      }
      let holder = this.$refs.my_timegraph;
      if (!holder || !holder.getBoundingClientRect) {
        return this.fixed_height || 400;
      }
      let viewportH = document.documentElement.clientHeight || window.innerHeight;
      let footer = document.getElementById("footer");
      let footerH = footer ? footer.offsetHeight : 0;
      let actionsBar = holder.querySelector(".tg_actions_bar");
      let actionsH = actionsBar && actionsBar.offsetHeight ? actionsBar.offsetHeight : 36;
      if (this.overview_series != null && !this.disable_zoom) {
        actionsH += OVERVIEW_HEIGHT + OVERVIEW_GAP;
      }
      const GAP = 8; // small breathing room above the footer
      let container = this.$refs[this.unique_identifier];
      let main = container && container.closest
        ? container.closest(".mainpage, .mainpage_prj_tree_closed")
        : null;
      if (main) {
        let mainTop = main.getBoundingClientRect().top;
        let offsetWithinMain =
          holder.getBoundingClientRect().top - mainTop + main.scrollTop;
        let containerVisibleHeight = viewportH - footerH - mainTop;
        return Math.max(containerVisibleHeight - offsetWithinMain - actionsH - GAP, 300);
      }
      return Math.max(
        viewportH - footerH - holder.getBoundingClientRect().top - actionsH - GAP,
        300
      );
    },
    available_graph_width() {
      let container = this.$refs[this.unique_identifier];
      if (!container || !container.getBoundingClientRect) {
        return this.fixed_width || this.width || 800;
      }
      let viewport = document.documentElement.clientWidth || window.innerWidth;
      let holder = this.$refs.my_timegraph;
      let graphArea = holder ? holder.querySelector(".tg_timegraph") : null;
      let plotLeft = (graphArea || container).getBoundingClientRect().left;

      let renderExtra = 70 + (this.show_channel_control_panel ? 0 : 200);

      const RIGHT_CHROME = 28;

      return Math.max(viewport - plotLeft - RIGHT_CHROME - renderExtra, 200);
    },
    on_window_resize() {
      this.resize();
      if (!this.diagram && !this.autoshift) this.on_displayed_area_changed(true);
    },
    resize() {
      if (!this.use_custom_size && this.diagram == null && !this.capture_image) {
        this.width = this.available_graph_width();
      }
      else if (this.fixed_width == null) {
        let f = this.$refs[this.unique_identifier];
        this.width = f.clientWidth;
      }
      else {
        this.width = this.fixed_width;
      }
      if (!this.use_custom_size && this.diagram == null && !this.capture_image) {
        this.height = this.available_graph_height();
      }
      else if (this.fixed_height == null) {
        this.height = 400;
      }
      else {
        this.height = this.fixed_height;
      }
      if (this.use_custom_size)
      {
        this.width = this.custom_width;
        this.height = this.custom_height;
      }

      let graph_interval_begin = this.start_date;
      let graph_interval_end = this.end_date;
      if (this.autoshift) {
        let now = Date.now();
        let original_duration = this.end_date - this.start_date;
        graph_interval_begin = now - original_duration;
        graph_interval_end = now;
      }
      this.update_graph(graph_interval_begin, graph_interval_end);
    },
    mousedown(event) {
      this.dragChannel = false;
      if (this.axisDrag) return;
      if (!this.magnify_mode && this.magnify_start_position == null) {
        this.on_pan_start(event.clientX);
        this.isPanning = true;
      }
      this.resize();
    },
    mouseUp() {
      const wasAxisDrag = this.axisDrag != null;
      this.axisDrag = null;
      if (this.isPanning) {
        this.isPanning = false;
        this.emitDiagramSettings();
      }
      if (wasAxisDrag) {
        this.axesData.selectedX = false;
        this.axesData.selectedIndex = -1;
      }
    },
    axis_drag_start(index, isX, clientX, clientY) {
      this.axisDrag = { index, isX };
      this.isPanning = true;
      if (isX) this.on_pan_start(clientX);
      else this.on_pan_y_start(clientY);
    },
    axis_drag_move(clientX, clientY) {
      if (!this.axisDrag || !this.$ui.mousedown) return;
      if (this.axisDrag.isX) this.on_pan(clientX);
      else this.on_pan_y(clientY);
    },
    axis_hover(index, isX) {
      if (isX) {
        this.axesData.selectedX = true;
        this.axesData.selectedIndex = -1;
      } else {
        this.axesData.selectedX = false;
        this.axesData.selectedIndex = index;
      }
    },
    axis_unhover() {
      if (this.isPanning) return;
      this.axesData.selectedX = false;
      this.axesData.selectedIndex = -1;
    },
    mousedrag(event) {
      if (this.dragChannel || this.axisDrag)
        return;
      this.last_mouse_client_x = event.clientX;
      this.last_mouse_client_y = event.clientY;
      if (this.$ui.mousedown && !this.magnify_mode) {
        this.on_pan(event.clientX);
      }
    },
    on_pan_start(mouse_x_position) {
      this.offset_ms_before_pan = this.offset_ms;
      this.pan_start_x_pos = mouse_x_position;
    },
    pan_y_index() {
      return this.axisDrag ? this.axisDrag.index : this.axesData.selectedIndex;
    },
    pan_y_index_valid(i) {
      return i >= 0 && !!this.axesData.transpose[i] && !!this.axesData.array[i];
    },
    on_pan_y_start(mouse_y_position) {
      const i = this.pan_y_index();
      if (!this.pan_y_index_valid(i)) return;
      this.offset_y_before_pan = this.axesData.transpose[i].offset;
      this.pan_start_y_pos = mouse_y_position;
    },
    on_pan_y(mouse_y_position) {
      const i = this.pan_y_index();
      if (!this.pan_y_index_valid(i)) return;
      let delta_y = (mouse_y_position - this.pan_start_y_pos) * 1;
      this.axesData.transpose[i].offset = this.offset_y_before_pan + delta_y;
      this.axesData.transpose[i].unit = this.axesData.array[i].unit;
      this.axesData.transpose[i].gi = this.axesData.array[i].gi;
      // console.log("on_pan_y");
      this.resize();
    },
    on_pan(mouse_x_position) {
      if (this.displayedDates != null) {
        let ms_per_pixel = (this.displayedDates.maxDate - this.displayedDates.minDate) /
          this.width;
        let delta_ms = (this.pan_start_x_pos - mouse_x_position) * ms_per_pixel;
        this.offset_ms = this.offset_ms_before_pan + delta_ms;
        // console.log("on_pan");
        this.on_displayed_area_changed(true);
        this.resize();
      }
    },
    on_click_graph(timestamp) {
      if (this.magnify_mode) {
        if (this.magnify_start_position == null) {
          this.start_magnifying(timestamp);
        }
        else {
          this.finish_magnifying(timestamp);
        }
      }
    },
    on_click_axis_label(axisIndex, unitLabel,
      override_y_axis_scale, 
      override_y_axis_scale_min,
      override_y_axis_scale_max, 
      grid, zero_line, 
      draw_line_at, draw_line_at_value, label) {
      this.axis_options.title = this.$txt.axis_settings + ":" + unitLabel;
      this.axis_options.unitLabel = unitLabel;
      this.axis_options.override_y_axis_scale = override_y_axis_scale; 
      this.axis_options.override_y_axis_scale_min = override_y_axis_scale_min;
      this.axis_options.override_y_axis_scale_max = override_y_axis_scale_max; 
      this.axis_options.grid = grid;
      this.axis_options.zero_line = zero_line;
      this.axis_options.draw_line_at = draw_line_at;
      this.axis_options.draw_line_at_value = draw_line_at_value;
      this.axis_options.yLabel = label;
      this.axis_options_modal = true;
      this.new_graph_description = this.graph_description;
    },
    on_click_graph_description() {
      this.new_graph_description = this.graph_description;
      this.graph_description_modal = true;
    },
    start_magnifying(timestamp) {
      this.magnify_start_position = timestamp;
      this.resize();
    },
    finish_magnifying(timestamp) {
      this.set_displayed_area_to_dates(this.magnify_start_position, timestamp);
      this.on_displayed_area_changed(true);
      this.magnify_mode = false;
      this.magnify_start_position = null;
      this.resize();
    },
    set_displayed_area_to_dates(date1, date2) {
      this.reset_zoom_and_movement();
      let from = date1;
      let to = date2;
      if (date1 > date2) {
          to = date1;
          from = date2;
      }
      let area_duration = to - from;
      let default_duration = this.end_date - this.start_date;
      if (this.diagram?.xAxisZoom && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1 && !this.magnify_mode) {
        this.interval_scaling_factor = this.diagram?.xAxisZoom;
      } else {
        this.interval_scaling_factor = area_duration / default_duration;
      }
      // this.interval_scaling_factor = area_duration / default_duration;
      let avg_time = from + area_duration / 2;
      let default_avg_time = this.start_date + default_duration / 2;
      if (this.diagram?.xAxisOffset && this.diagram?.diagramSettings?.localSettings?.selected_recording == -1 && !this.magnify_mode) {
        this.offset_ms = this.diagram?.xAxisOffset;
      } else {
        this.offset_ms = avg_time - default_avg_time;
      }
    },
    handle_scroll(event) {
      //Prevents user to scroll unless any axis is selected.
      if (!this.axesData.selectedX && this.axesData.selectedIndex < 0) {
        return;
      }
      if (this.dragChannel) {
        return;
      }
      // Suppress page scroll synchronously (passive: false). Zoom application
      // is rAF-throttled below so a burst of wheel events collapses to one
      // render per frame.
      event.preventDefault();
      // Kept for the anchor point of the zoom, applied in the rAF below.
      this._wheel_client_x = event.clientX;
      this._wheel_client_y = event.clientY;
      this._wheel_delta_pending = (this._wheel_delta_pending || 0) + event.deltaY;
      if (this._wheel_raf == null) {
        this._wheel_raf = requestAnimationFrame(() => {
          this._wheel_raf = null;
          const deltaY = this._wheel_delta_pending;
          this._wheel_delta_pending = 0;
          this.apply_scroll_delta(deltaY);
        });
      }
    },
    apply_scroll_delta(deltaY) {
      if (!this.zoomYAxis(deltaY)) {
        this.zoomXAxis(deltaY);
      }
      this.on_displayed_area_changed(true);
      // Skip the clientWidth re-measure in resize() — the width doesn't change
      // during scroll-zoom, and reading it after Vue has dirtied the DOM forces
      // a synchronous layout (the "Forced reflow while executing JavaScript"
      // violation in console). Use the cached this.width by calling update_graph
      // directly with the current interval.
      let begin = this.start_date;
      let end = this.end_date;
      if (this.autoshift) {
        const now = Date.now();
        const dur = this.end_date - this.start_date;
        begin = now - dur;
        end = now;
      }
      this.update_graph(begin, end);
    },
    on_displayed_area_changed(cache_this_display_request = false) {
      this.display_area_change_tstamp = Date.now();
      if (this.displayedDates != null) {
        window.setTimeout(() => {
          this.$emit("displayed_area_changed", {
            minDate: this.displayedDates.minDate,
            maxDate: this.displayedDates.maxDate
          }, 0, this);
        });
      }
      window.setTimeout(this.reload_data, this.wait_before_load, this, cache_this_display_request);
    },
    reload_data(that, cache_this_display_request) {
      let deltaTime = Date.now() - that.display_area_change_tstamp;
      if (deltaTime >= this.wait_before_load) {
        that.display_area_change_tstamp = Date.now();
        let minDate, maxDate;
        if (that.displayedDates != null) {
        let overshoot = that.area_overshoot *
            (that.displayedDates.maxDate - that.displayedDates.minDate);
        minDate = that.displayedDates.minDate - overshoot;
        maxDate = that.displayedDates.maxDate + overshoot;
        } else {
        // Use initial start_date and end_date when displayedDates is null
        minDate = that.start_date;
        maxDate = that.end_date;
        }
        that.$emit("reload_data", {
          minDate: minDate,
          maxDate: maxDate,
          cache: cache_this_display_request,
          plotWidth: that.plot_width_px(),
          overviewFrom: that.overview_range.from,
          overviewTo: that.overview_range.to
        });
      }
    },

    pan_to_center(center_ms) {
      const base_center = this.start_date + (this.end_date - this.start_date) / 2;
      this.offset_ms = center_ms - base_center;
      this.offset_ms_before_pan = this.offset_ms;
      this.on_displayed_area_changed(true);
      this.resize();
    },

    set_view_range({ from, to }) {
      const base = this.end_date - this.start_date;
      if (!(base > 0) || !(to > from)) return;
      this.interval_scaling_factor = (to - from) / base;
      this.offset_ms = (from + to) / 2 - (this.start_date + base / 2);
      this.offset_ms_before_pan = this.offset_ms;
      this.on_displayed_area_changed(true);
      this.resize();
    },
    update_overview_frame() {
      const range = this.axesData.xRange;
      const width = Number(this.$refs.abc?.getAttribute("width"));
      if (!range || !(width > 0)) return;
      const f = this.overview_frame;
      if (f && f.width === width && f.x0 === range[0] && f.x1 === range[1]) return;
      this.overview_frame = { width, x0: range[0], x1: range[1] };
    },

    plot_width_px() {
      if (this._last_plot_width > 0) return this._last_plot_width;
      let width = this.use_custom_size
        ? this.custom_width
        : (this.width > 1 ? this.width : this.available_graph_width());
      return Math.max(width - this.dynamicPaddingXLeft - this.dynamicPaddingXRight, 100);
    },

    //   reload_data(that, cache_this_display_request) {
    //       let deltaTime = Date.now() - that.display_area_change_tstamp;
    //       if (deltaTime >= this.wait_before_load) {
    //           that.display_area_change_tstamp = Date.now();
    //           let overshoot = that.area_overshoot *
    //               (that.displayedDates.maxDate - that.displayedDates.minDate);
    //           that.$emit("reload_data", {
    //               minDate: that.displayedDates.minDate - overshoot,
    //               maxDate: that.displayedDates.maxDate + overshoot,
    //               cache: cache_this_display_request
    //           });
    //       }
    //   },
    toggle_hidden(s) {
      if (this.is_hidden(s)) {
      this.$emit('toggle-hidden-series', s.id, false);
      } else {
      this.$emit('toggle-hidden-series', s.id, true);
      }
      this.persist_channel_selection();
    },
    is_hidden(s) {
      return this.graph_buffer.hidden_series.includes(s.id);
    },
    sort_channel_groups(groups) {
      const ORDER = ["Potential", "Voltage", "Current", "Resistance", "Temperature", "ppm"];
      const rank = (group) => {
        const i = ORDER.indexOf(group.type_label ?? group.label);
        const type_rank = i === -1 ? ORDER.length : i;

        return (group.is_ps ? 0 : 1) * 100 + type_rank;
      };
      return groups.slice().sort((a, b) => rank(a) - rank(b));
    },
    channel_group_info(serie) {
      const type_label = this.channel_type_label(serie.unit);
      const is_ps = this.ps_channel_ids.has(serie.id);
      return {
        label: is_ps ? "PS " + type_label : type_label,
        type_label,
        is_ps
      };
    },
    channel_type_label(unit) {
      const u = (unit || "").trim().toLowerCase();
      if (u === "mv") return "Potential";
      if (u === "v") return "Voltage";
      if (u === "a" || u === "ma") return "Current";
      if (u.includes("ohm") || u === "Ω" || u === "kΩ") return "Resistance";
      if (u.includes("c") && (u.includes("°") || u === "c")) return "Temperature";
      return unit || "Other";
    },
    is_group_all_shown(group) {
      return group.series.every(s => !this.is_hidden(s));
    },
    toggle_group(group) {
      const targetHidden = this.is_group_all_shown(group);
      for (const s of group.series) {
        if (this.is_hidden(s) !== targetHidden) {
          this.toggle_hidden(s);
        }
      }
      this.emitDiagramSettings();
      this.resize();
    },
    is_section_all_shown(section) {
      return section.groups.every(g => this.is_group_all_shown(g));
    },
    toggle_section(section) {
      const targetHidden = this.is_section_all_shown(section);
      for (const group of section.groups) {
        for (const s of group.series) {
          if (this.is_hidden(s) !== targetHidden) {
            this.toggle_hidden(s);
          }
        }
      }
      this.emitDiagramSettings();
      this.resize();
    },
    download_img() {
      // console.log("download_img");
      if (this.download_format == "svg") {
        this.$util.svg_element_download_as_file(document.getElementById(this.canvas_id), "test");
      }
      else {
        this.$util.svg_element_to_img_download(document.getElementById(this.canvas_id), "test");
      }
    },
    reset_zoom_and_movement() {
      this.interval_scaling_factor = 1;
      this.offset_ms = 0;
      this.offset_ms_before_pan = 0;
    },
    reset_zoom_to_natural() {
      this.interval_scaling_factor = this.natural_scaling_factor;
      this.offset_ms = this.natural_offset_ms;
      this.offset_ms_before_pan = this.natural_offset_ms;
      this.reset_y_axis_zoom();
    },
    reset_y_axis_zoom() {
      if (!this.axesData || !Array.isArray(this.axesData.transpose)) return;
      for (const a of this.axesData.transpose) {
        if (!a) continue;
        a.zoomFactor = 1.0;
        a.offset = 0.0;
        a.unit = "";
        a.gi = 0;
        a.baseMin = null;
        a.baseMax = null;
      }
      this.offset_y_before_pan = 0;
    },
    show_channel_serie_options(s) {
      this.channel_serie = s;
      this.channel_serie_options.title = this.$txt.channel_serie_settings + ":" + s.name;
      if (this.$app.settings.display_internal_id) {
        let internal_id_string = " (" + this.$txt.internal_id + ":" + s.id + ")";
        this.channel_serie_options.title += internal_id_string;
        }
      this.channel_serie_options_modal = true;
      this.channel_serie_options.override_y_axis_scale = s.override_y_axis_scale;
      this.channel_serie_options.override_y_axis_scale_min = s.override_y_axis_scale_min;
      this.channel_serie_options.override_y_axis_scale_max = s.override_y_axis_scale_max;
      this.channel_serie_options.grid = s.grid;
      this.channel_serie_options.zero_line = s.zero_line;
      this.channel_serie_options.draw_line_at = s.draw_line_at;
      this.channel_serie_options.draw_line_at_value = s.draw_line_at_value;
      this.channel_serie_options.yLabel = s.yLabel;
      this.channel_serie_options.yPos = s.yPos;
      this.channel_serie_options.graph_type = s.graph_type;
    },
    submit_channel_serie_options() {
      this.channel_serie.override_y_axis_scale = this.channel_serie_options.override_y_axis_scale;
      this.channel_serie.override_y_axis_scale_min = this.channel_serie_options.override_y_axis_scale_min;
      this.channel_serie.override_y_axis_scale_max = this.channel_serie_options.override_y_axis_scale_max;

      this.channel_serie.grid = this.channel_serie_options.grid;
      this.channel_serie.zero_line = this.channel_serie_options.zero_line;
      this.channel_serie.draw_line_at = this.channel_serie_options.draw_line_at;
      this.channel_serie.draw_line_at_value = this.channel_serie_options.draw_line_at_value;
      this.channel_serie.yLabel = this.channel_serie_options.yLabel;

      this.channel_serie.yPos = this.channel_serie_options.yPos;
      this.channel_serie.graph_type = this.channel_serie_options.graph_type;

      let thisUnit = this.channel_serie.unit;
      let thisYPos = this.channel_serie.yPos;

      globalSettings.temp_storage_off_channel_series = [];
      for (let i = 0; i < this.channel_series.length; i++) {
        if ((this.channel_series[i].unit == thisUnit) && (this.channel_series[i].yPos == thisYPos)) {
          this.channel_series[i].override_y_axis_scale = this.channel_serie_options.override_y_axis_scale;
          this.channel_series[i].override_y_axis_scale_min = this.channel_serie_options.override_y_axis_scale_min;
          this.channel_series[i].override_y_axis_scale_max = this.channel_serie_options.override_y_axis_scale_max;
          this.channel_series[i].grid = this.channel_serie_options.grid;
          this.channel_series[i].zero_line = this.channel_serie_options.zero_line;
          this.channel_series[i].draw_line_at = this.channel_serie_options.draw_line_at;
          this.channel_series[i].draw_line_at_value = this.channel_serie_options.draw_line_at_value;
          this.channel_series[i].yLabel = this.channel_serie_options.yLabel;
          if (!this.diagram) {
            globalSettings.temp_storage_off_channel_series.push(this.channel_series[i]);
          }
        }
      }
      // this.emitDiagramSettings();
    },
    applyAxisSettingsFromPanel(unitLabel, axisObj) {
      const ref = axisObj
               || this.channel_series.find(s => s.unit === unitLabel && s.yLabel)
               || this.channel_series.find(s => s.unit === unitLabel);
      if (!ref) return;
      const isDefault = this.selected_graph_setting == 999996;
      for (const s of this.channel_series) {
        if (s.unit !== unitLabel) continue;
        s.grid = ref.grid;
        s.zero_line = ref.zero_line;
        s.draw_line_at = ref.draw_line_at;
        s.draw_line_at_value = ref.draw_line_at_value;
        s.yLabel = ref.yLabel;
        s.yPos = ref.yPos;
        if (this.is_hidden(s)) continue;
        if (isDefault) {
          s.graph_min = ref.graph_min;
          s.graph_max = ref.graph_max;
        } else {
          s.override_y_axis_scale = ref.override_y_axis_scale;
          s.override_y_axis_scale_min = ref.override_y_axis_scale_min;
          s.override_y_axis_scale_max = ref.override_y_axis_scale_max;
        }
      }
      this.resize();
      this.emitDiagramSettings();
    },
    isAxisVisible(unitLabel) {
      return this.channel_series.some(s => s.unit === unitLabel && !this.is_hidden(s));
    },
    toggleAxisChannels(unitLabel) {
      const anyVisible = this.isAxisVisible(unitLabel);
      for (const s of this.channel_series) {
        if (s.unit !== unitLabel) continue;
        if (anyVisible && !this.is_hidden(s)) {
          this.toggle_hidden(s);
        } else if (!anyVisible && this.is_hidden(s)) {
          this.toggle_hidden(s);
        }
      }
      this.resize();
      this.emitDiagramSettings();
    },
    submit_axis_options() {
      this.graph_description = this.new_graph_description;
      globalSettings.temp_storage_off_channel_series = [];
      for (let i = 0; i < this.channel_series.length; i++) {
        if (this.channel_series[i].unit == this.axis_options.unitLabel) {
          this.channel_series[i].override_y_axis_scale = this.axis_options.override_y_axis_scale;
          this.channel_series[i].override_y_axis_scale_min = this.axis_options.override_y_axis_scale_min;
          this.channel_series[i].override_y_axis_scale_max = this.axis_options.override_y_axis_scale_max;
          this.channel_series[i].grid = this.axis_options.grid;
          this.channel_series[i].zero_line = this.axis_options.zero_line;
          this.channel_series[i].draw_line_at = this.axis_options.draw_line_at;
          this.channel_series[i].draw_line_at_value = this.axis_options.draw_line_at_value;
          this.channel_series[i].yLabel = this.axis_options.yLabel;
        }
        if (!this.diagram) {
          globalSettings.temp_storage_off_channel_series.push(this.channel_series[i]);
        }
      }
      this.emitDiagramSettings();
    },
    submit_graph_description() {  
      this.graph_description = this.new_graph_description;
      this.graph_description_modal = false;
    },
    update_graph(begin, end) {
      if (this.channel_series.length !== (this.series?.length || 0)) {
        this.channel_series = (this.series || []).slice();
        this.sort_series_based_on_project_tree();
      }
      if (this.raf_id == null) {
        this.raf_id = requestAnimationFrame(() => this.render_internal(begin, end));
      }
    },
    default_settings() {
      if (this.selected_graph_setting == 999996) {
        this.preset_is_selected = true;
        this.resetDiagramSettingsBool = true;
        this.selected_graph_setting = 999996;
        this.graph_description = this.default_graph_description;

        if (this.diagram) {
          this.use_custom_size=false;
          this.custom_width=1000;
          this.custom_height=800;
        } else {
          let sizeJson = localStorage.getItem('timegraph_custom_size');
          if (sizeJson != null) {
            try {
              let s = JSON.parse(sizeJson);
              this.use_custom_size = s.use_custom_size ?? false;
              this.custom_width = s.custom_width ?? 1000;
              this.custom_height = s.custom_height ?? 800;
            } catch (e) {
              this.use_custom_size = false;
              this.custom_width = 1000;
              this.custom_height = 800;
            }
          }
        }

        this.download_format="png";
        for (let i = 0; i < this.channel_series.length; i++) {
          if (globalSettings.temp_storage_off_channel_series.length && !this.diagram) {
            for (let serie of globalSettings.temp_storage_off_channel_series) {
              if (this.channel_series[i].unit == serie.unit) {
                this.channel_series[i].override_y_axis_scale = serie.override_y_axis_scale;
                this.channel_series[i].override_y_axis_scale_min = serie.override_y_axis_scale_min;
                this.channel_series[i].override_y_axis_scale_max = serie.override_y_axis_scale_max;
                this.channel_series[i].grid = serie.grid;
                this.channel_series[i].zero_line = serie.zero_line;
                this.channel_series[i].draw_line_at = serie.draw_line_at;
                this.channel_series[i].draw_line_at_value = serie.draw_line_at_value;
                this.channel_series[i].yLabel = serie.yLabel;
                this.channel_series[i].yPos = serie.yPos;
                this.channel_series[i].graph_type = serie.graph_type;
              }
            }
          } else {
            this.set_default_serie_setting(i);
          }
          this.channel_series[i].override_y_axis_scale = false;
          // if (this.is_hidden(this.channel_series[i])) {
          //   this.toggle_hidden(this.channel_series[i])
          // }
          this.channel_series[i].settings_updated = true;
        }
        
        this.emitDiagramSettings();
      }
    },
    default_mre_settings() {
      if (this.selected_graph_setting == 1000001) {
        this.preset_is_selected = true;
        if (this.diagram) {
          this.use_custom_size = true
          this.custom_height = 700;
        }
        // console.log("this.series: ", this.series)
        for (let serie of this.channel_series) {
          let nodeObj =  this.getNodeType(serie.id)
          if (nodeObj.node.capability == Camur.node_type.ntype_mre) {
            if (this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          } else {
            if (!this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          }
          // console.log("nodeobj", nodeObj)
          serie.yPos = 0;
          serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "kOhm";
          serie.yLabel = "Resistance"
          serie.override_y_axis_scale = true;
          serie.override_y_axis_scale_max = 100;
          serie.override_y_axis_scale_min = 0;
          serie.draw_line_at = false;
          serie.grid = true;
          // serie.draw_line_at_value = 100;
          // console.log("serie", serie)
          // console.log("nodeobj: ", nodeObj)
        }
        this.emitDiagramSettings();
        // this.resize();
      }
    },

    default_zra_settings() {
      if (this.selected_graph_setting == 1000000) {
        this.preset_is_selected = true;
        if (this.diagram) {
          this.use_custom_size = true
          this.custom_height = 700;
        }
        // console.log("this.series: ", this.series)
        for (let serie of this.series) {
          let nodeObj =  this.getNodeType(serie.id)
          // console.log("nodeobj: ", nodeObj)
          if ((nodeObj.node.locals.nodeTypeName !== "CorroWatch" && nodeObj.node.locals.nodeTypeName !== "AnodeLadder" && !Camur.is_power_supply(nodeObj.node.capability)) || Camur.is_p_node(nodeObj.node.capability)) {
            // console.log("is p node", Camur.is_p_node(nodeObj.node.capability) )
            // console.log("is power supply", nodeObj.node.is_power_supply)
            if (!this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          } else {
            if (this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
            if (Camur.is_power_supply(nodeObj.node.capability)) {
              if (nodeObj.channel.code == "U") {
                serie.yPos = 1;
                serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "V"
                serie.yLabel = "Voltage"
                serie.override_y_axis_scale = true;
                serie.override_y_axis_scale_max = 5;
                serie.override_y_axis_scale_min = 0;
                // console.log("serie with U", serie)
              }
              if (nodeObj.channel.code == "T" || nodeObj.channel.code == "Usupply" || nodeObj.channel.code == "Uterm" || nodeObj.channel.code == "I") {
                if (!this.is_hidden(serie)) {
                  this.toggle_hidden(serie)
                }
              }
            }
            if (nodeObj.node.locals.nodeTypeName == "CorroWatch" || nodeObj.node.locals.nodeTypeName == "AnodeLadder" || nodeObj.node.locals.nodeTypeName == "ZRA") {
              if (/^I\d+$/.test(nodeObj.channel.code) || nodeObj.channel.code == "I") {
                serie.yPos = 0;
                serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "mA";
                serie.yLabel = "Current"
                serie.override_y_axis_scale = true;
                serie.override_y_axis_scale_max = 0.5;
                serie.override_y_axis_scale_min = 0;
              } else {
                if (!this.is_hidden(serie)) {
                  this.toggle_hidden(serie)
                }
              }
            }
            serie.grid = true;
          }
        }
        this.emitDiagramSettings();
        // this.resize();
      }
    },
    plotted_value(pt) {
      if (!pt) return null;
      let raw;
      if (pt.value != null) raw = pt.value;
      else if (pt.avgVal != null) raw = pt.avgVal;
      else if (pt.minVal != null && pt.maxVal != null) raw = (Number(pt.minVal) + Number(pt.maxVal)) / 2;
      else raw = pt.minVal ?? pt.maxVal;
      const num = Number(raw);
      return isFinite(num) ? num : null;
    },
    default_decay_results_scaling_settings() {
      if (this.selected_graph_setting != 1000002) return;
      if (!this.series.length) return;
      let highestValue = 0;
      for (const s of this.series) {
        if (!s.data?.length || this.is_hidden(s)) continue;
        for (const pt of s.data) {
          const val = this.plotted_value(pt);
          if (val != null && val > highestValue) highestValue = val;
        }
      }
      if (!highestValue) return;
      const scale = Math.max(Math.ceil(highestValue / 10) * 10 + 10, 100);
      for (const s of this.channel_series) {
        s.override_y_axis_scale = true;
        s.override_y_axis_scale_max = scale;
        s.override_y_axis_scale_min = 0;
      }
      this.resize();
    },
    default_decay_results_settings() {
      if (this.selected_graph_setting == 999999 || this.selected_graph_setting == 1000002) {
        this.preset_is_selected = true;
        if (this.diagram) {
          this.use_custom_size = true
          this.custom_height = 700;
        }

        for (let serie of this.channel_series) {
          let nodeObj =  this.getNodeType(serie.id)
          serie.yPos = 0;
          const diagramSerie = this.diagram_backup?.diagramSettings?.series?.find(d => d.id === serie.id);
          serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "mV";
          serie.yLabel = "Depolarization"
          serie.override_y_axis_scale = true;
          if (diagramSerie?.override_y_axis_scale_max) {
            serie.override_y_axis_scale_max = diagramSerie?.override_y_axis_scale_max;
          } else {
            serie.override_y_axis_scale_max = 200;
          }
          if (diagramSerie?.override_y_axis_scale_min) {
            serie.override_y_axis_scale_min = diagramSerie?.override_y_axis_scale_min
          } else {
            serie.override_y_axis_scale_min = 0;
          }
          // serie.override_y_axis_scale_max = 200;
          // serie.override_y_axis_scale_min = 0;
          serie.draw_line_at = true;
          serie.grid = true;

          if (Camur.is_p_node(nodeObj.node.capability)) {
            if (this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          } else {
            if (!this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          }
        }
        // if (this.graph_buffer.hidden_series.length) {
        //   this.$emit("reload-diagram")
        // }
        this.emitDiagramSettings();
        if (this.selected_graph_setting == 1000002) {
          this.$nextTick(() => this.default_decay_results_scaling_settings());
        }
        // this.resize();
      }
    },
    roundUpNice(val) {
      // Rounds up to 1 significant figure: 0.349→0.4 | 3.2→4 | 32→40
      if (!val || val <= 0) return val;
      const magnitude = Math.pow(10, Math.floor(Math.log10(val)));
      return Math.ceil(val / magnitude) * magnitude;
    },
    default_operating_data_scaling_settings() {
      if (this.selected_graph_setting == 999998) {
        this.preset_is_selected = true;
        if (this.diagram) {
          this.use_custom_size = true
          this.custom_height = 700;
        }

        for (let serie of this.series) {
          let nodeObj =  this.getNodeType(serie.id)
          const diagramSerie = this.diagram_backup?.diagramSettings?.series?.find(d => d.id === serie.id);
          serie.override_y_axis_scale = true;

          if (Camur.is_p_node(nodeObj?.node?.capability) || nodeObj?.node?.is_power_supply) {
            if (this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
            if (nodeObj.node.is_power_supply) {
              serie.override_y_axis_scale_min = 0;

              if (nodeObj.channel.code == "U") {
                serie.yPos = 2;
                serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "V"
                serie.yLabel = "Voltage"

                const diagramMax = diagramSerie?.override_y_axis_scale_max;
                let limit;

                switch (nodeObj.node.capability) {
                  case Camur.node_type.ntype_fv01:
                    limit = 5;
                    break;
                  default:
                    limit = 10;
                    break;
                }

                if (diagramSerie?.override_y_axis_scale_max) {
                  serie.override_y_axis_scale_max = diagramMax;
                } else {
                  serie.override_y_axis_scale_max = limit;
                }
              }

              if (nodeObj.channel.code === "I") {
                serie.yPos = 1;
                serie.unit = nodeObj.channel.formula.unit ? nodeObj.channel.formula.unit : "A";
                serie.yLabel = "Current";

                const diagramMax = diagramSerie?.override_y_axis_scale_max;
                let limit;

                switch (nodeObj.node.capability) {
                  case Camur.node_type.ntype_fv1a:
                    limit = 1.2;
                    break;
                  case Camur.node_type.ntype_fv01:
                    limit = 0.12;
                    break;
                  case Camur.node_type.ntype_fv3:
                    limit = 3.5;
                    break;
                  case Camur.node_type.ntype_fv8:
                    limit = 9;
                    break;
                  default:
                    limit = 0.35;
                    break;
                }

                if (diagramSerie?.override_y_axis_scale_max) {
                  serie.override_y_axis_scale_max = diagramMax;
                } else {
                  serie.override_y_axis_scale_max = limit;
                }
              }

              if (nodeObj.channel.code == "T" || nodeObj.channel.code == "Usupply" || nodeObj.channel.code == "Uterm") {
                if (!this.is_hidden(serie)) {
                  this.toggle_hidden(serie)
                }
              }
            }

            if (Camur.is_p_node(nodeObj.node.capability)) {
              serie.yPos = 0;
              serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "mV";
              serie.yLabel = "Potential"
              if (diagramSerie?.override_y_axis_scale_max) {
                serie.override_y_axis_scale_max = diagramSerie?.override_y_axis_scale_max;
              } else {
                serie.override_y_axis_scale_max = 0;
              }
              if (diagramSerie?.override_y_axis_scale_min) {
                serie.override_y_axis_scale_min = diagramSerie?.override_y_axis_scale_min
              } else {
                serie.override_y_axis_scale_min = -1000;
              }
            }
            serie.grid = true;
          } else {
            if (!this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          }
        }
        // Second pass: if data is loaded, override PSU caps with actual measured maxes per axis.
        // Skip hidden series — they default to yPos=0 (graph_pos_bottom) but are unrelated
        // to the potential axis, so their minVal would corrupt axisMin[0].
        const axisMax = {};
        const axisMin = {};
        for (const s of this.series) {
          if (!s.data?.length || !s.override_y_axis_scale || this.is_hidden(s)) continue;
          const yp = s.yPos;
          for (const pt of s.data) {
            if (!pt) continue;
            if (pt.maxVal > (axisMax[yp] ?? -Infinity)) axisMax[yp] = pt.maxVal;
            if (pt.minVal < (axisMin[yp] ?? Infinity)) axisMin[yp] = pt.minVal;
          }
        }
        for (const s of this.series) {
          if (!s.override_y_axis_scale) continue;
          const yp = s.yPos;
          const dmax = axisMax[yp];
          const dmin = axisMin[yp];
          if (dmax == null || dmin == null) continue;
          if (dmax === 0 && dmin === 0) continue;

          const follows_negative = yp === 0;

          if (dmax > 0) {
            s.override_y_axis_scale_max = this.roundUpNice(dmax);
          } else if (follows_negative) {
            s.override_y_axis_scale_max = 0;
          }
          if (follows_negative && dmin < 0) {
            s.override_y_axis_scale_min = -this.roundUpNice(Math.abs(dmin));
          } else {
            s.override_y_axis_scale_min = 0;
          }
        }
        this.emitDiagramSettings();
        // this.resize();
      }
    },
    default_operating_data_settings() {
      if (this.selected_graph_setting == 999997) {
        this.preset_is_selected = true;
        if (this.diagram) {
          this.use_custom_size = true
          this.custom_height = 700;
        }
        for (let serie of this.series) {
          let nodeObj =  this.getNodeType(serie.id)
          const diagramSerie = this.diagram_backup?.diagramSettings?.series?.find(d => d.id === serie.id);
          if (Camur.is_p_node(nodeObj.node.capability) || nodeObj.node.is_power_supply) {
            if (this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
            if (nodeObj.node.is_power_supply) {
              if (nodeObj.channel.code == "U") {
                serie.yPos = 2;
                serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "V"
                serie.yLabel = "Voltage"
                // serie.override_y_axis_scale = true;
                if (diagramSerie?.override_y_axis_scale) {
                  serie.override_y_axis_scale = diagramSerie.override_y_axis_scale;
                }
                serie.override_y_axis_scale_max = 10;
                serie.override_y_axis_scale_min = 0;
              }
              if (nodeObj.channel.code == "I") {
                serie.yPos = 1;
                serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "A"
                serie.yLabel = "Current"
                // serie.override_y_axis_scale = true;
                if (diagramSerie?.override_y_axis_scale) {
                  serie.override_y_axis_scale = diagramSerie.override_y_axis_scale;
                }
                serie.override_y_axis_scale_max = 10;
                serie.override_y_axis_scale_min = 0;
              }
              if (nodeObj.channel.code == "T" || nodeObj.channel.code == "Usupply" || nodeObj.channel.code == "Uterm") {
                if (!this.is_hidden(serie)) {
                  this.toggle_hidden(serie)
                }
              }
            }
            if (Camur.is_p_node(nodeObj.node.capability)) {
              serie.yPos = 0;
              serie.unit = nodeObj.channel.formula.unit? nodeObj.channel.formula.unit : "mV";
              serie.yLabel = "Potential"
              // serie.override_y_axis_scale = true;
              if (diagramSerie?.override_y_axis_scale) {
                serie.override_y_axis_scale = diagramSerie.override_y_axis_scale;
              }
              serie.override_y_axis_scale_max = 0;
              serie.override_y_axis_scale_min = -1000;
            }
            serie.grid = true;
          } else {
            if (!this.is_hidden(serie)) {
              this.toggle_hidden(serie)
            }
          }
        }
        this.emitDiagramSettings();
        // this.resize();
      }
    },
    loadGraphPresets(applyChannels = false) {
      if (!this.series.length || this.series == null || this.series == undefined) return
      this.preset_is_selected = false;
      const interactive = (this.diagram == null);
      const restoreChannels = interactive && !applyChannels && this.has_persisted_channels;
      this.applying_preset = interactive;

      // if it's a **custom** preset (from your DB), id < 900000,
      // delegate immediately to the DB-loader and stop.
      if (this.selected_graph_setting != null  && this.selected_graph_setting < 900000) {
        this.load_graph_settings(this.selected_graph_setting);
        // force an emit so the parent knows which preset is now active
        this.emitDiagramSettings();
        // return;
      }

      if (this.diagram?.diagramSettings) {
        let settings = this.diagram.diagramSettings
        this.graph_description = settings.graph_description;
        this.show_legend = settings.show_legend;
        this.show_channel_control_panel = settings.show_channel_control_panel;
        this.use_custom_size = settings.use_custom_size;
        this.custom_width = settings.custom_width;
        this.custom_height = settings.custom_height;
        this.download_format = settings.download_format;
      }
      // console.log("selected_graph_setting", this.selected_graph_setting)
      this.default_settings();
      this.default_operating_data_scaling_settings();
      this.default_operating_data_settings();
      this.default_zra_settings();
      this.default_decay_results_settings();
      this.default_mre_settings();

      if (restoreChannels) {
        this.$emit("set-hidden-series", [...this.persisted_hidden]);
      }
      this.applying_preset = false;
      if (interactive && applyChannels) {
        this.has_persisted_channels = false;
        this.persisted_hidden = [];
        try { localStorage.removeItem("C3_TG_hidden_" + this.localStorageId); } catch (e) {}
      }
    },
    save_hidden_series_to_localStorage() {
      if (this.diagram != null) return;
      try {
        localStorage.setItem(
          "C3_TG_hidden_" + this.localStorageId,
          JSON.stringify(this.graph_buffer.hidden_series || [])
        );
      } catch (e) {}
    },
    has_operating_data_nodes() {
      const nodes = this.$app.sltd.zone?.nodes ?? this.$app.sltd.cntrl?.nodes ?? [];
      const hasPnode = nodes.some(n => Camur.is_p_node(n.capability) && n.serial);
      const hasFixvolt = nodes.some(n => n.is_power_supply && n.serial);
      return hasPnode && hasFixvolt;
    },
    getNodeType(serieId) {
      let source;
      if (this.$app.sltd.zone) {
        source = this.$app.sltd.zone.nodes;
      }
      else if (this.$app.sltd.cntrl) {
        source = this.$app.sltd.cntrl.nodes;
      } else {
        source = this.$app.sltd.project.all_nodes;
      }
      for (let node of source) {
        for (let channel of Object.values(node.channels)) {
          if (channel.id === serieId) {
            let value = { node: node, channel: channel}
            return value;
          }
        }    
      }
    },
    settingIdOf(name) {
      let existingGraphProps = this.available_graph_settings.filter(s => (s.name == name));
      if (existingGraphProps.length < 1)        
        return 0;
      else
        return existingGraphProps[0].id;
    },
    settingOf(name) {
      let existingGraphProps = this.available_graph_settings.filter(s => (s.name == name));
      if (existingGraphProps.length < 1)        
        return 0;
      else
        return existingGraphProps[0];
    },
    getNameOfGraphProps(id) {
      if (this.$app.graph_props == null)          
        return "";
      let selectedGraphProps = this.$app.graph_props.filter(s => (s.id == id));
      if (selectedGraphProps.length < 1)
        return "";
      else
        return selectedGraphProps[0].name;
    },
    getValueOfGraphProps(id) {
      let selectedGraphProps = this.$app.graph_props.filter(s => (s.id == id));
      if (selectedGraphProps.length < 1)
        return "";
      else
        return selectedGraphProps[0].value;
    },
    prepare_to_save_graph_settings_as() {
      this.save_graph_settings_as_name = "";
      this.save_graph_settings_as_modal = true;
    },
    settings_object() {
      let settings = {};
      settings.graph_description = this.graph_description;
      settings.show_legend = this.show_legend;
      settings.show_channel_control_panel = this.show_channel_control_panel;

      settings.use_custom_size = this.use_custom_size;
      settings.download_format = this.download_format;
      settings.custom_width=this.custom_width;
      settings.custom_height=this.custom_height;

      let series = [];
      for (let i = 0; i < this.channel_series.length; i++) {
        let serie = {};
        // Save only the attributes needed
        serie.id = this.channel_series[i].id;

        if (this.channel_series[i].override_y_axis_scale == null)
          serie.override_y_axis_scale = false;
        else
          serie.override_y_axis_scale = this.channel_series[i].override_y_axis_scale;

        if (this.channel_series[i].override_y_axis_scale_min == null)
          serie.override_y_axis_scale_min = 0;
        else
          serie.override_y_axis_scale_min = this.channel_series[i].override_y_axis_scale_min;

        if (this.channel_series[i].override_y_axis_scale_max == null)
          serie.override_y_axis_scale_max = 200;
        else
          serie.override_y_axis_scale_max = this.channel_series[i].override_y_axis_scale_max;

        if (this.channel_series[i].grid == null)
          serie.grid = false;
        else
          serie.grid = this.channel_series[i].grid;

        if (this.channel_series[i].zero_line == null)
          serie.zero_line = false;
        else
          serie.zero_line = this.channel_series[i].zero_line;

        if (this.channel_series[i].draw_line_at == null)
          serie.draw_line_at = false;
        else
          serie.draw_line_at = this.channel_series[i].draw_line_at;

        if (this.channel_series[i].draw_line_at_value == null)
          serie.draw_line_at_value = 100;
        else
          serie.draw_line_at_value = this.channel_series[i].draw_line_at_value;

        if (this.channel_series[i].yLabel == null)
          serie.yLabel = "";
        else
          serie.yLabel = this.channel_series[i].yLabel;

        if (this.channel_series[i].yPos == null)
          serie.yPos = this.$enum.graph_pos.graph_pos_bottom;
        else
          serie.yPos = this.channel_series[i].yPos;

        if (this.channel_series[i].graph_type == null)
          serie.graph_type = this.$enum.graph_type.graph_type_line;
        else
          serie.graph_type = this.channel_series[i].graph_type;

        series.push(serie);
      }
      settings.series = series;
      settings.hidden_series = this.graph_buffer.hidden_series;
      return settings;
    },
    settings_string() {
      return JSON.stringify(this.settings_object());
    },
    reset_graph_settings(refresh, resetDiagramSettings) {
      globalSettings.temp_storage_off_channel_series = [];
      if (this.diagram && this.diagram.diagramSettings && resetDiagramSettings == false && this.diagram_backup?.selected_graph_setting < 900000) {
        this.load_graph_settings_from_saved_report_diagram()
        return;
      }
      else if (this.diagram) {
        this.blockWatcherEmits = true;
        this.resetDiagramSettingsBool = true;
        this.selected_graph_setting = 999996;
        this.loadGraphPresets();
        this.on_selection_changed();
      } else {
        this.selected_graph_setting = 999996;
        this.has_persisted_channels = false;
        this.persisted_hidden = [];
        try { localStorage.removeItem("C3_TG_hidden_" + this.localStorageId); } catch (e) {}
        this.default_settings();
        this.on_selection_changed();
      }
      if (refresh) {
        this.reset_zoom_and_movement();
        this.natural_scaling_factor = 1;
        this.natural_offset_ms = 0;

        this.reset_y_axis_zoom();

        this.magnify_mode = false;
        this.magnify_start_position = null;
        this.axesData.selectedX = false;

        this.on_displayed_area_changed(true);

        this.resize();
        this.emitDiagramSettings();
        this.$emit("reload-graph");
      }
      this.blockWatcherEmits = false;
    },
    save_graph_settings() {
      let valueJsonStr = this.settings_string();
      // console.log("graph settings?: ", valueJsonStr);
      let zoneId = 0;
      if (this.zone != null) 
        zoneId = this.zone.id;

      let controllerId = 0;
      if (this.controller != null) 
        controllerId = this.controller.id;

      //console.log(valueJsonStr);
      let name = this.getNameOfGraphProps(this.selected_graph_setting);
      if (valueJsonStr != this.getValueOfGraphProps(this.selected_graph_setting)) {
        this.$net.graph_props.update(this.$app.sltd.project.id, this.selected_graph_setting, {
          controllerId : controllerId,
          zoneId: zoneId,
          name: name,
          value: valueJsonStr
        });
      }
    },
    save_graph_settings_as() {
      let valueJsonStr = this.settings_string();

      let zoneId = 0;
      if (this.zone != null) 
        zoneId = this.zone.id;

      let controllerId = 0;
      if (this.controller != null) 
        controllerId = this.controller.id;

      //console.log(valueJsonStr);
      // setting already exists?
      let id = this.settingIdOf(this.save_graph_settings_as_name);
      if (id > 0) {
        if (valueJsonStr != this.getValueOfGraphProps(id)) {
          this.$net.graph_props.update(this.$app.sltd.project.id, id, {
            controllerId : controllerId,
            zoneId: zoneId,
            name: this.save_graph_settings_as_name,
            value: valueJsonStr
          });
        }
      }
      else {
        this.$net.graph_props.create(this.$app.sltd.project.id, {
          controllerId : controllerId,
          zoneId: zoneId,
          name: this.save_graph_settings_as_name,
          value: valueJsonStr
        });
      }
    },

    save_formula_defaults() {
      for (let serie of this.channel_series) {
        if (this.is_hidden(serie)) continue;
        const nodeObj = this.getNodeType(serie.id);
        if (!nodeObj?.channel?.formula?.id) continue;
        const formula = nodeObj.channel.formula;
        if (serie.graph_min === formula.graphScaleMin && serie.graph_max === formula.graphScaleMax) continue;
        this.$net.formula.update(
          this.$app.sltd.project.id,
          formula.id,
          {
            graphScaleMin: serie.graph_min,
            graphScaleMax: serie.graph_max,
          }
        );
      }
    },

    delete_graph_setting(id) {
      this.$net.graph_props.delete(this.$app.sltd.project.id, id);
    },

    set_default_serie_setting(i) {
      this.channel_series[i].override_y_axis_scale = false;
      this.channel_series[i].override_y_axis_scale_min = 0;
      this.channel_series[i].override_y_axis_scale_max = 200;
      this.channel_series[i].grid = false; 
      this.channel_series[i].zero_line = false;
      this.channel_series[i].draw_line_at = false;
      this.channel_series[i].draw_line_at_value = 100;
      this.channel_series[i].yLabel = "";
      this.channel_series[i].yPos = this.$enum.graph_pos.graph_pos_bottom;        
      this.channel_series[i].graph_type = this.$enum.graph_type.graph_type_line;   
      // Other defaults for Decay result
      if (this.report_type == this.$camur.report_type.reptype_decay_results) {
        this.channel_series[i].override_y_axis_scale = true;
        this.channel_series[i].grid = true;
        this.channel_series[i].draw_line_at = true;
        this.channel_series[i].yLabel = "Depolarization";
      }
    },

    disable_settings_loaded_from_report() {
      this.settings_loaded_from_report = false;
      this.emitDiagramSettings();
      if (this.diagram || this._preset_changes_report_type()) {
        this.$emit("reload-graph");
      }
    },

    _preset_changes_report_type() {
      const s = this.selected_graph_setting;
      const cur = this.report_type;
      const DECAY = this.$camur.report_type.reptype_decay_results; // 7
      if (s == 999999 || s == 1000002) return cur != DECAY;
      if (s == 999997 || s == 999998) return cur == DECAY;
      return false;
    },

    reload_stored_settings() {
      this.$emit("reload-diagram")
      this.$nextTick(() => {
        this.$emit("reload-graph");
      });
    },

    load_graph_settings_from_saved_report_diagram() {
      if (this.diagram) {
        if (this.diagram.diagramPreset > 0 || this.diagram.selected_graph_setting > 900000) {
          this.selected_graph_setting = this.diagram.selected_graph_setting || this.diagram.diagramPreset
          this.loadGraphPresets();
          return;
        }
        else if (this.diagram && this.diagram.diagramSettings) {
          let settings;
          if (this.reloadingReportSettingsBool && this.diagram_backup?.selected_graph_setting < 900000) {
            this.selected_graph_setting = this.diagram_backup.selected_graph_setting;
            settings = JSON.parse(this.getValueOfGraphProps(this.selected_graph_setting));
          } else {
            this.selected_graph_setting = this.diagram.selected_graph_setting
            if (this.selected_graph_setting) {
              settings = JSON.parse(this.getValueOfGraphProps(this.selected_graph_setting));
            } else {
              settings = this.diagram.diagramSettings;
            }
          }
          this.graph_description = settings.graph_description;
          this.show_legend = settings.show_legend;
          this.show_channel_control_panel = settings.show_channel_control_panel;
          this.use_custom_size = settings.use_custom_size;
          this.custom_width = settings.custom_width;
          this.custom_height = settings.custom_height;
          this.download_format = settings.download_format;
  
          // Handle series and hidden_series
          for (let serie of settings.series) {
            // find the matching channel in channel_series
            const existing = this.channel_series.find(cs => cs.id === serie.id);
            if (!existing) {
              // channel doesn't exist, skip or create a new one
              continue;
            }
            
            // Set channel_serie so submit_channel_serie_options() can use it
            this.channel_serie = existing;
  
            this.channel_serie_options.override_y_axis_scale = serie.override_y_axis_scale;
            this.channel_serie_options.override_y_axis_scale_min = serie.override_y_axis_scale_min;
            this.channel_serie_options.override_y_axis_scale_max = serie.override_y_axis_scale_max;
  
            this.channel_serie_options.grid = serie.grid;
            this.channel_serie_options.zero_line = serie.zero_line;
            this.channel_serie_options.draw_line_at = serie.draw_line_at;
            this.channel_serie_options.draw_line_at_value = serie.draw_line_at_value;
            this.channel_serie_options.yLabel = serie.yLabel;
  
            this.channel_serie_options.yPos = serie.yPos;
            this.channel_serie_options.graph_type = serie.graph_type;
            this.channel_serie.settings_updated = true;
            this.submit_channel_serie_options();
          }

          this.$emit('set-hidden-series', settings.hidden_series);
          this.emitDiagramSettings();
          
          this.settings_loaded_from_report = true;
          this.resize();
        } else {
          this.emitDiagramSettings();
        }
      }
    },

    load_graph_settings(id) {
      // console.log("load_graph_settings for id:"+ id);
      if (this.$app.graph_props) {
        let selectedGraphProps = this.$app.graph_props.filter(s => (s.id == id));
        // console.log("selectedGraphProps: ", selectedGraphProps)
        // console.log("all graph_props: ", this.$app.graph_props)
        if (selectedGraphProps.length >= 1) {
          let valueString = selectedGraphProps[0].value;
          //console.log("load_graph_settings for id:"+ id + " :"+ valueString);
          let value = JSON.parse(valueString);
          if (value.graph_description == null) {
            this.graph_description = this.default_graph_description;
          }
          else {
            this.graph_description = value.graph_description;
          }
          this.show_legend = value.show_legend;
          this.show_channel_control_panel = value.show_channel_control_panel;
  
          this.use_custom_size=value.use_custom_size;
          this.download_format=value.download_format;
          this.custom_width=value.custom_width;
          this.custom_height=value.custom_height;
  
          this.$emit('set-hidden-series', value.hidden_series);
          for (let i = 0; i < this.channel_series.length; i++) {
            let s = this.channel_series[i];
            let setting = value.series.filter(gs => (gs.id == s.id));
            if (setting != null) {
              if (setting.length >= 1) {
                if (setting[0].override_y_axis_scale == null)
                  this.channel_series[i].override_y_axis_scale = false;
                else
                  this.channel_series[i].override_y_axis_scale = setting[0].override_y_axis_scale;
  
                if (setting[0].override_y_axis_scale_min == null)
                  this.channel_series[i].override_y_axis_scale_min = 0;
                else
                  this.channel_series[i].override_y_axis_scale_min = setting[0].override_y_axis_scale_min;
  
                if (setting[0].override_y_axis_scale_max == null)
                  this.channel_series[i].override_y_axis_scale_max = 200;
                else
                  this.channel_series[i].override_y_axis_scale_max = setting[0].override_y_axis_scale_max;
  
                if (setting[0].grid == null) {  
                  this.channel_series[i].grid = false;                       
                }
                else {
                  this.channel_series[i].grid = setting[0].grid;
                }
                if (setting[0].zero_line == null) {  
                  this.channel_series[i].zero_line = false;
                }
                else {
                  this.channel_series[i].zero_line = setting[0].zero_line;  
                }
                if (setting[0].draw_line_at == null) {  
                  this.channel_series[i].draw_line_at = false;
                }
                else {
                  this.channel_series[i].draw_line_at = setting[0].draw_line_at;  
                }
                if (setting[0].draw_line_at_value == null) {  
                  this.channel_series[i].draw_line_at_value = 100;
                }
                else {
                  this.channel_series[i].draw_line_at_value = setting[0].draw_line_at_value;  
                }
                if (setting[0].yLabel == null) {
                  this.channel_series[i].yLabel = "";
                }
                else {
                  this.channel_series[i].yLabel = setting[0].yLabel;    
                }    
                if (setting[0].yPos == null) {
                  this.channel_series[i].yPos = this.$enum.graph_pos.graph_pos_bottom;
                }
                else {
                  this.channel_series[i].yPos = setting[0].yPos;
                }
                if (setting[0].graph_type == null) {
                  this.channel_series[i].graph_type = this.$enum.graph_type.graph_type_line;
                }
                else {
                  this.channel_series[i].graph_type = setting[0].graph_type;
                }
                this.channel_series[i].settings_updated = true;
              }
              else {
                // Set defaults
                this.set_default_serie_setting(i);
                this.channel_series[i].settings_updated = true;
              }
            }
            else {
              // Set defaults
              this.set_default_serie_setting(i);
              this.channel_series[i].settings_updated = true;
            }
          }
          // console.log("Load " + this.graph_description);
          this.resize();
        }
      }
      else {
        for (let i = 0; i < this.channel_series.length; i++) {
          this.set_default_serie_setting(i);
          this.channel_series[i].settings_updated = true;
        }
      }
    },
    render_internal(graph_interval_begin, graph_interval_end) {
      this.raf_id = null;
      let options = {
          width: this.use_custom_size ? this.custom_width : this.width,
          height: this.use_custom_size ? this.custom_height : this.height,
          click_callback: this.on_click_graph,
          highlighted_samples_callback: this.set_highlighted_samples,
          axis_drag_start: (index, isX, clientX, clientY) => this.axis_drag_start(index, isX, clientX, clientY),
          axis_drag_move: (clientX, clientY) => this.axis_drag_move(clientX, clientY),
          axis_hover: (index, isX) => this.axis_hover(index, isX),
          axis_unhover: () => this.axis_unhover(),
          startDate: graph_interval_begin,
          endDate: graph_interval_end,
          paddingXLeft: this.dynamicPaddingXLeft,
          paddingXRight: this.dynamicPaddingXRight,
          paddingY: this.paddingY,
          canvasId: this.canvas_id,
          area_overshoot: this.area_overshoot,
          maxPointDensity: this.points_density_threshold,
          show_highlights: !this.$ui.mousedown,
          offset_ms: this.offset_ms,
          thick: this.thick,
          interval_scaling_factor: this.interval_scaling_factor,
          position: graph_interval_begin +
              (graph_interval_end - graph_interval_begin) / 2,
          magnify_start_position: this.magnify_start_position,
          disable_zoom: this.disable_zoom,
          axis_options_callback: this.on_click_axis_label,
          graph_description: this.graph_description,
          graph_description_callback: this.on_click_graph_description,
          show_legend: this.show_legend,
          firstYAxisLeft:this.firstYAxisLeft,
          recordings: this.graph_buffer?.recordings ?? [],
          // Format a recording id into "12345 (Decay)" using the recording type
          // text. The renderer calls this on hover to populate #tg_recording_display.
          // Decay results are fetched with a value tag, and those samples carry
          // no recording id — fall back to the recording whose time span
          // contains the hovered timestamp.
          format_recording_label: (recordingId, hovered_time) => {
            const recs = this.graph_buffer?.recordings;
            if (recordingId == null) {
              const rec = this.find_recording_at_time(hovered_time, recs);
              if (!rec) return "";
              const typeText = this.$camur.get_rectype_text(rec.dto?.type);
              return typeText ? `${rec.id} (${typeText})` : String(rec.id);
            }
            if (!recs) return String(recordingId);
            const rec = recs.find(r => r.id === recordingId);
            if (!rec) return String(recordingId);
            const typeText = this.$camur.get_rectype_text(rec.dto?.type);
            return typeText ? `${recordingId} (${typeText})` : String(recordingId);
          },
          last_mouse_client_x: this.last_mouse_client_x,
          last_mouse_client_y: this.last_mouse_client_y,
          clear_mouse_position: () => { this.last_mouse_client_x = null; this.last_mouse_client_y = null; },
          // Live-values mode: channels stream samples at slightly different
          // timestamps, so the global "snap point" jumps to whichever channel
          // just ticked. The hover logic uses this flag to drop the
          // tooFar-from-snap exclusion and show each channel's own closest
          // sample independently — otherwise every other channel goes blank
          // whenever one channel updates.
          autoshift: this.autoshift,
        };
      //console.log("render_internal, channel_series.length:" + this.channel_series.length)
      if (!this.show_channel_control_panel) {
        options.width += 200;
      }
      if (this.show_legend) {
        let maxWidth = 0;
        // console.log("channel series: ", this.channel_series)
        this.channel_series.forEach(channel => {
          if (!this.is_hidden(channel) && channel.name) {
            let width = 0;

            for (let char of channel.name) {
              if (char.toUpperCase() === char && char.toLowerCase() !== char) {
                // Uppercase letter
                width += (char === "I") ? 6 : 13;
              } else if (char.toLowerCase() === char && char.toUpperCase() !== char) {
                // Lowercase letter
                width += ["i", "l", "r", "t"].includes(char) ? 6 : 7;
              } else if (!isNaN(char)) {
                // Number
                width += (char === "1") ? 7 : 11;
              } else {
                // Symbol, space, etc.
                width += 9;
              }
            }
            maxWidth = Math.max(maxWidth, width);
          }
        });
        // console.log("options.paddingXRight: before adding maxwidth", options.paddingXRight)
        // console.log("options.paddingXRight: MAX WIDTH", maxWidth)
        
        options.paddingXRight += maxWidth;
        // console.log("options.paddingXRight: ", options.paddingXRight)
        if (options.paddingXRight < 150) {
          options.paddingXRight = 150;
        }
      }
      this._last_plot_width = options.width - options.paddingXLeft - options.paddingXRight;

      // this.sort_series_based_on_project_tree();
      // Check every series, not just [0]: a series that arrives in a later block
      // is appended with settings_updated/override_y_axis_scale = false, and if
      // [0] was already configured the preset would never be applied to it —
      // leaving it to veto the axis override in render_graph.
      if (this.channel_series.some(s => !s.settings_updated)) {
        if (globalSettings.available_graph_settings_presets.some(preset => preset.id == this.selected_graph_setting)) {
          this.loadGraphPresets();
          this.channel_series.forEach(s => (s.settings_updated = true));
        }
        else if (this.selected_graph_setting != null){
          this.load_graph_settings(this.selected_graph_setting);
        }
        else {
          this.reset_graph_settings (false, this.resetDiagramSettingsBool);
        }
      }

      let t_stamp = Date.now();
      try {
        this.displayedDates = render_graph(options, this.axesData, this.channel_series, this.graph_buffer.hidden_series ,this.alarm_level_low, this.alarm_level_high, this.showHoldValues, this.unique_identifier);
      } catch {}
      this.update_overview_frame();
      window.graph_update_time = Date.now() - t_stamp;

      // Only capture image when explicitly requested (during report generation)
      if (this.capture_image) {
        this.updateImageSrc();
      }
    },

    sort_series_based_on_project_tree() {
      // console.log("sort_based_on_tree_called")
      const sorted_channels = [];

      const channelSort = (a, b) =>
        (a?.io ?? 99) - (b?.io ?? 99) ||
        (a?.no ?? 9999) - (b?.no ?? 9999) ||
        (a?.id ?? 0) - (b?.id ?? 0);

      const pushNode = (node) => {
        const perNode = Object.values(node.channels || {}).sort(channelSort);
        sorted_channels.push(...perNode);
      };

      if (this.$app.sltd.zone) {
        const sorted_nodes = this.$util.sort_table(this.$app.sltd.zone.nodes, "sortIndex");
        for (const node of sorted_nodes) pushNode(node);
      }
      else if (this.$app.sltd.cntrl && !this.$app.sltd.zone) {
        const sorted_zones = this.$util.sort_table(this.$app.sltd.cntrl.zones, "sortIndex");
        for (const zone of sorted_zones) {
          const sorted_nodes = this.$util.sort_table(zone.nodes, "sortIndex");
          for (const node of sorted_nodes) pushNode(node);
        }
      }
      else if (this.$app.sltd.project && !this.$app.sltd.cntrl && !this.$app.sltd.zone) {
        const sorted_cntrls = this.$util.sort_table(this.$app.sltd.project.cntrls, "sortIndex");
        for (const cntrl of sorted_cntrls) {
          const sorted_zones = this.$util.sort_table(cntrl.zones, "sortIndex");
          for (const zone of sorted_zones) {
            const sorted_nodes = this.$util.sort_table(zone.nodes, "sortIndex");
            for (const node of sorted_nodes) pushNode(node);
          }
        }
      }

      this.applySeriesOrderFrom(sorted_channels);
    },

    applySeriesOrderFrom(sorted_channels) {
      const wantedIds = new Set((this.channel_series || []).map(s => String(s.id)));
      const order = new Map();
      let rank = 0;
      for (const ch of sorted_channels || []) {
        const id = String(ch?.id);
        if (wantedIds.has(id) && !order.has(id)) order.set(id, rank++);
      }
      const originalIndex = new Map(
        (this.channel_series || []).map((s, i) => [String(s.id), i])
      );
      const INF = Number.POSITIVE_INFINITY;

      const sorted = [...(this.channel_series || [])].sort((a, b) => {
        const ra = order.has(String(a.id)) ? order.get(String(a.id)) : INF;
        const rb = order.has(String(b.id)) ? order.get(String(b.id)) : INF;
        if (ra !== rb) return ra - rb;
        return originalIndex.get(String(a.id)) - originalIndex.get(String(b.id));
      });

      this.channel_series = sorted;   // replace, don't mutate
    },

    updateImageSrc() {
      const svgElement = document.getElementById(this.canvas_id);
      if (!svgElement) return;
      if (this.diagram) {
        this.download_format = 'svg';
      }
      // Grab the “natural” dims (you could also use viewBox if you prefer)
      let naturalWidth  = parseFloat(svgElement.getAttribute("width"));
      let naturalHeight = parseFloat(svgElement.getAttribute("height"));

      // if those attributes aren't set, fall back to the bounding box
      if (!naturalWidth || !naturalHeight) {
        const rect = svgElement.getBoundingClientRect();
        naturalWidth  = rect.width;
        naturalHeight = rect.height;
      }

      const scaleFactor = 1;  // ↑ ramp this up for even more resolution

      if (this.download_format === 'svg') {
        // 1) Clone the SVG so we don't stomp on the onscreen one
        const clone = svgElement.cloneNode(true);
        // Hide hover-only elements that are invisible via CSS class in the browser
        // but lose that styling when the SVG is serialized (CSS classes are not applied).
        clone.querySelectorAll('.tg_only_on_hover').forEach(el => { el.style.display = 'none'; });
        const magnifyRect = clone.querySelector('#tg_magnify_rect');
        if (magnifyRect) magnifyRect.style.display = 'none';

        // 2) Bump its own width/height by our scale factor
        clone.setAttribute("width",  naturalWidth  * scaleFactor);
        clone.setAttribute("height", naturalHeight * scaleFactor);

        // 3) Serialize & base64
        const serializer = new XMLSerializer();
        const svgData    = serializer.serializeToString(clone);
        const base64Data = btoa(unescape(encodeURIComponent(svgData)));
        const dataUrl    = "data:image/svg+xml;base64," + base64Data;

        // 4) Emit
        this.$emit("image-updated", {
          src:    dataUrl,
          width:  naturalWidth,
          height: naturalHeight
        });
      }
      else {
        if (svgElement) {
          // Convert SVG to PNG data URL
          const svgData = new XMLSerializer().serializeToString(svgElement);
          const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
          const URLObj = window.URL || window.webkitURL || window;
          const blobURL = URLObj.createObjectURL(svgBlob);

          const img = new Image();
          img.crossOrigin = 'Anonymous'; // Important for cross-origin images

          img.onload = () => {
            // Define a scale factor to increase resolution (try 2 or 3)
            const scaleFactor = 2;
            // Use naturalWidth and naturalHeight if available, otherwise fallback to client dimensions
            const svgWidth = naturalWidth || svgElement.clientWidth;
            const svgHeight = naturalHeight || svgElement.clientHeight;

            // Set up a higher-resolution canvas
            const canvas = document.createElement('canvas');
            canvas.width = svgWidth * scaleFactor;
            canvas.height = svgHeight * scaleFactor;
            const context = canvas.getContext('2d');

            // Scale the drawing context
            context.scale(scaleFactor, scaleFactor);
            context.drawImage(img, 0, 0, svgWidth, svgHeight);

            // Optionally, disable image smoothing for a crisper look
            // context.imageSmoothingEnabled = false;

            // Convert canvas to PNG data URL
            const dataUrl = canvas.toDataURL('image/png');

            // Emit the image data to the parent component
            this.$emit('image-updated', {
              src: dataUrl,
              width: svgWidth,
              height: svgHeight
            });

            // Clean up
            URLObj.revokeObjectURL(blobURL);
          };

          img.onerror = (error) => {
            console.error('Error converting SVG to PNG:', error);
            // Handle the error as needed
          };

          img.src = blobURL;
        }
      }
    },
    sort_string(a) {
      // sortStr will provide a unique string id
      // with a defined sort-order
      let sortStr=a.name + "-" + (10000 + a.id);
      return sortStr;
    },
    // Resolve which recording a timestamp belongs to, for samples that carry no
    // recording id of their own (decay results are fetched per value tag and
    // the server returns no recording id with them). A recording whose stop is
    // missing (still running) counts as open ended. If several match — nested
    // or overlapping recordings — the one starting last wins, since that is the
    // most specific.
    find_recording_at_time(time_ms, recordings) {
      if (time_ms == null || !recordings || !recordings.length) return null;
      const t = time_ms instanceof Date ? time_ms.getTime() : Number(time_ms);
      if (!Number.isFinite(t)) return null;
      let best = null;
      let best_start = -Infinity;
      for (const rec of recordings) {
        const start = new Date(rec.start).getTime();
        if (!Number.isFinite(start) || start > t) continue;
        const stop = rec.stop ? new Date(rec.stop).getTime() : Infinity;
        if (Number.isFinite(stop) && stop < t) continue;
        if (start >= best_start) {
          best_start = start;
          best = rec;
        }
      }
      return best;
    },
    set_highlighted_samples(samples, meta) {
      this.highlighted_samples = samples;
      this.hover_meta = (meta && (meta.time || meta.recording)) ? meta : null;
    },
    on_selection_changed() {
      this.reset_zoom_and_movement();
      this.resize();
      this.on_displayed_area_changed(true);
    },
    startDrag (evt, item) {
      this.dragChannel = true;
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('itemID', item.id);
      // Drop the hovered-axis target, so the drag cannot be read as a zoom or pan
      // of whichever axis the cursor last crossed.
      this.axesData.selectedIndex = -1;
    },
    // dragend fires whether the channel was dropped on a graph or the drag was
    // abandoned, so it is the one place that always clears the flag. While the flag
    // is set, scroll-zoom and panning are suppressed; leaving it set would keep
    // them disabled until the next mousedown on the graph.
    endDrag () {
      this.dragChannel = false;
    },
    onDrop (evt, list) {
      this.axesData.selectedIndex = -1;
      const itemID = evt.dataTransfer.getData('itemID');
      // console.log("Dropped:"+itemID+" at ("+evt.clientX + ", "+evt.clientY+")");	  
      // console.log(evt);
      let tg = document.getElementById(this.unique_identifier+"my_timegraph");
      let divRect = tg.getBoundingClientRect();

      let visible_series = this.channel_series.filter(s => !this.graph_buffer.hidden_series.includes(s.id));
      let items = this.channel_series.filter(s => (itemID == s.id));
      let item = items[0];
      // console.log("item:"+item);

      let graph_positions = stacked_graph_positions(visible_series);
      let graph_N = graph_positions.length;

      // Dropped position in Time-graph
      let yPos = Math.floor(evt.clientY - divRect.y);
      let yGraphHeight = (this.height - 2 * this.paddingY) / graph_N;
      /*console.log("yPos:"+yPos);
      console.log("paddingY:"+this.paddingY);
      console.log("yGraphHeight:"+yGraphHeight);
      console.log("this.height:"+this.height); */

      let droppedYPos = Enum.graph_pos.graph_pos_bottom;
      if (yPos < this.paddingY) {

        let aboveYPos = graph_positions[graph_N - 1] + 1;
        if (aboveYPos <= Enum.graph_pos.graph_pos_top) {
          droppedYPos = aboveYPos;
          // console.log("Dropped YPos:", droppedYPos);
          this.channel_serie = item;
          this.channel_serie_options.override_y_axis_scale = item.override_y_axis_scale;
          this.channel_serie_options.override_y_axis_scale_min = item.override_y_axis_scale_min;
          this.channel_serie_options.override_y_axis_scale_max = item.override_y_axis_scale_max;
          this.channel_serie_options.grid = item.grid;
          this.channel_serie_options.zero_line = item.zero_line;
          this.channel_serie_options.draw_line_at = item.draw_line_at;
          this.channel_serie_options.draw_line_at_value = item.draw_line_at_value;
          this.channel_serie_options.yLabel = item.yLabel;
          this.channel_serie_options.graph_type = item.graph_type;
          this.channel_serie_options.yPos = droppedYPos;
          this.submit_channel_serie_options();
          this.resize();
        }
        // else ignore
      }
      else if (yPos > (this.height - this.paddingY)) {
        // Below graphs, ignore 
      }
      else {
        let yIndex = Math.floor((yPos - this.paddingY) / yGraphHeight);
        let row = Math.min(Math.max((graph_N-1) - yIndex, 0), graph_N-1);
        droppedYPos = graph_positions[row];
        // console.log("Dropped YPos:", droppedYPos);
        this.channel_serie = item;
        this.channel_serie_options.override_y_axis_scale = item.override_y_axis_scale;
        this.channel_serie_options.override_y_axis_scale_min = item.override_y_axis_scale_min;
        this.channel_serie_options.override_y_axis_scale_max = item.override_y_axis_scale_max;
        this.channel_serie_options.grid = item.grid;
        this.channel_serie_options.zero_line = item.zero_line;
        this.channel_serie_options.draw_line_at = item.draw_line_at;
        this.channel_serie_options.draw_line_at_value = item.draw_line_at_value;
        this.channel_serie_options.yLabel = item.yLabel;
        this.channel_serie_options.graph_type = item.graph_type;
        this.channel_serie_options.yPos = droppedYPos;
          this.submit_channel_serie_options();
          this.resize();
      }
      this.emitDiagramSettings();
      this.dragChannel = false;
    }
  },
  props: {
    graph_settings_open: {
      type: Boolean,
      default: null
    },
    selected_graph_setting_prop: {
      type: [Number, String],
      default: null
    }, //used for recorded values when swapping between zones
    graph_buffer: {
      type: Object,
      default: null
    },
    series: {
        type: Array,
        default: null
    },
    image: {
        type: Object,
        default: null,
    },
    autoshift: {
        type: Boolean,
        default: false
    },
    fixed_height: {
        // If null, fit parent
        type: Number,
        default: null
    },
    fixed_width: {
        // If null, fit parent
        type: Number,
        default: null
    },
    paddingXLeft: {
        type: Number,
        default: 0
    },
    paddingXRight: {
        type: Number,
        default: 0
    },
    paddingY: {
        type: Number,
        default: 40
    },
    firstYAxisLeft: {
      type: Boolean,
      default: true
    },
    alarm_level_low: {
        // If null, dont show
        type: Number,
        default: null
    },
    alarm_level_high: {
        // If null, dont show
        type: Number,
        default: null
    },
    points_density_threshold: {
        type: Number,
        default: 30
    },
    area_overshoot: {
        // How far off screen should we draw points?
        // (As a fraction of the graph width)
        type: Number,
        default: 0
    },
    graph_state: {
        type: Number,
        default: 0
    },
    unique_identifier: {
        type: String
    },
    start_date: {
        type: Number,
        default: null
    },
    end_date: {
        type: Number,
        default: null
    },
    overview_series: {
        type: Array,
        default: null
    },
    overview_version: {
        type: Number,
        default: 0
    },
    report_type: {
        type: Number,
        default: null
    },
    watching: {
        default: null
    },
    watching2: {
        default: null
    },
    thick: {
        type: Boolean,
        default: false
    },
    requested_zoom_interval: {
        type: Object,
        default: null
    },
    disable_zoom: {
        type: Boolean,
        default: false
    },
    show_channel_controls: {
        type: Boolean,
        default: false
    },
    is_loading_data: {
        type: Boolean,
        default: false
    },
    loading_progress: {
        type: String,
        default: ""
    },
    has_hold_values: {
        type: Boolean,
        default: false
    },
    has_fill_channels: {
        type: Boolean,
        default: false
    },
    has_select_nodes: {
        type: Boolean,
        default: false
    },
    select_mode: {
        type: Boolean,
        default: false
    },
    zone:{
      type: Object,
      default: null
    },
    controller:{
      type: Object,
      default: null
    },
    nodes:{
      type: Array,
      default: null
    },
    default_graph_description: {
      type: String,
      default: ""          
    },
    local_storage_id: {
      type: String,
      default: ""          
    },
    diagram: {
      type: Object,
      default: null,
    },
    diagram_backup: {
      type: Object,
      default: null
    },
    capture_image: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    y_axis_is_zoomed() {
      const transpose = this.axesData?.transpose;
      if (!Array.isArray(transpose)) return false;
      return transpose.some(a => a && (a.zoomFactor != 1.0 || a.offset != 0.0));
    },
    // Compact key of the project-tree order in the current context. Reading each
    // node/zone/controller's locals.sortIndex makes this reactive, so reordering
    // in the tree fires the watcher that re-sorts the channel list + graph (which
    // otherwise only re-sorted on render / page refresh).
    tree_node_order_key() {
      const parts = [];
      const addNodes = (nodes) => {
        for (const n of nodes || []) parts.push(`n${n.id}:${n?.locals?.sortIndex ?? ''}`);
      };
      if (this.$app.sltd.zone) {
        addNodes(this.$app.sltd.zone.nodes);
      } else if (this.$app.sltd.cntrl) {
        for (const z of this.$app.sltd.cntrl.zones || []) {
          parts.push(`z${z.id}:${z?.locals?.sortIndex ?? ''}`);
          addNodes(z.nodes);
        }
      } else if (this.$app.sltd.project) {
        for (const c of this.$app.sltd.project.cntrls || []) {
          parts.push(`c${c.id}:${c?.locals?.sortIndex ?? ''}`);
          for (const z of c.zones || []) {
            parts.push(`z${z.id}:${z?.locals?.sortIndex ?? ''}`);
            addNodes(z.nodes);
          }
        }
      }
      return parts.join(",");
    },

    ps_channel_ids() {
      const ids = new Set();
      const source =
        this.$app.sltd.project?.all_nodes ||
        this.$app.sltd.zone?.nodes ||
        this.$app.sltd.cntrl?.nodes ||
        [];
      for (const node of source) {
        if (!node.is_power_supply) continue;
        for (const channel of Object.values(node.channels || {})) {
          ids.add(channel.id);
        }
      }
      return ids;
    },
    channel_groups() {
      const groups = [];
      const byKey = {};
      for (const s of this.channel_series) {
        const info = this.channel_group_info(s);
        if (!byKey[info.label]) {
          byKey[info.label] = {
            key: info.label,
            label: info.label,
            type_label: info.type_label,
            is_ps: info.is_ps,
            series: []
          };
          groups.push(byKey[info.label]);
        }
        byKey[info.label].series.push(s);
      }
      return this.sort_channel_groups(groups);
    },

    channel_group_sections() {
      const ps = this.channel_groups.filter(g => g.is_ps);
      const rest = this.channel_groups.filter(g => !g.is_ps);
      const titled = ps.length > 0 && rest.length > 0;

      const sections = [];
      if (ps.length) {
        sections.push({ key: "ps", title: titled ? "Power supply" : "", groups: ps });
      }
      if (rest.length) {
        sections.push({ key: "sensors", title: titled ? "Sensors" : "", groups: rest });
      }
      return sections;
    },
    hovered_channels() {
      const out = [];
      for (const s of this.channel_series) {
        const h = this.highlighted_samples[s.id];
        if (!h) continue;
        let value;
        if ("value" in h) {
          if (!this.isFiniteNum(h.value)) continue;
          value = `${this.fmt(h.value, s.decimals)} ${s.unit}`;
        } else if (this.isFiniteNum(h.minVal)) {
          const lo = this.fmt(h.minVal, s.decimals);
          const hi = this.fmt(h.maxVal, s.decimals);
          value = (lo !== hi) ? `${lo} – ${hi} ${s.unit}` : `${lo} ${s.unit}`;
        } else {
          continue;
        }
        const info = this.channel_group_info(s);
        out.push({
          id: s.id,
          name: s.name,
          color: s.color,
          value,
          type: info.label,
          type_label: info.type_label,
          is_ps: info.is_ps
        });
      }
      return out;
    },
    hovered_channel_groups() {
      const groups = [];
      const byKey = {};
      for (const c of this.hovered_channels) {
        if (!byKey[c.type]) {
          byKey[c.type] = {
            key: c.type,
            label: c.type,
            type_label: c.type_label,
            is_ps: c.is_ps,
            rows: []
          };
          groups.push(byKey[c.type]);
        }
        byKey[c.type].rows.push(c);
      }
      return this.sort_channel_groups(groups);
    },
    hover_tooltip_style() {
      const x = this.last_mouse_client_x || 0;
      const y = this.last_mouse_client_y || 0;
      const offset = 16;
      const width = this.tooltip_width || 220;

      let diagramLeft = 0;
      const container = this.$refs[this.unique_identifier];
      if (container && container.getBoundingClientRect) {
        diagramLeft = container.getBoundingClientRect().left;
      }
      const placeRight = (x - offset - width) < diagramLeft;

      const vh = document.documentElement.clientHeight || window.innerHeight;
      const flipY = y > vh * 0.7;

      return {
        left: (placeRight ? x + offset : x - offset) + "px",
        top: (flipY ? y - offset : y + offset) + "px",
        transform: `translate(${placeRight ? "0" : "-100%"}, ${flipY ? "-100%" : "0"})`
      };
    },
    dynamicChannelPanelWidth() {
      if (!this.show_channel_control_panel) return '0px';

      let maxLength = 0;
      this.channel_series.forEach(channel => {
        if (channel.name) {
          maxLength = Math.max(maxLength, channel.name.length);
        }
      });

      // Estimate: ~8-10px per character, plus base width for checkboxes and spacing
      const extra = 250; // padding + checkbox space + icons etc
      const width = (maxLength * 9) + extra;

      return `${Math.max(width, 200)}px`; // set a minimum width
    },
    axesVisibilitySummary() {
      if (!this.axesData || !this.axesData.array) return "";
      return this.axesData.array
        .map(axis => axis.visible ? "1" : "0")
        .join(",");
    },
    dynamicPaddingXLeft() {
      // console.log("axesdata: ", this.axesData);
      let axisPadding = 40;
      
      const uniqueBottom = new Set();
      const uniqueHigh = new Set();
      const uniqueTop = new Set();
      
      if (this.axesData && this.axesData.array && this.axesData.array.length > 1) {
        for (let axis of this.axesData.array) {
          if (!axis.rightSide && axis.visible) {
            if (axis.gi === this.$enum.graph_pos.graph_pos_bottom) {
              uniqueBottom.add(axis.unit);
            } else if (axis.gi === this.$enum.graph_pos.graph_pos_high) {
              uniqueHigh.add(axis.unit);
            } else {
              uniqueTop.add(axis.unit);
            }
          }
        }
      }
      
      const numYAxesYposBot = uniqueBottom.size;
      const numYAxesYposHigh = uniqueHigh.size;
      const numYAxesYposTop = uniqueTop.size;
      
      // console.log("axes bot: ", uniqueBottom.size)
      // console.log("axes high: ", uniqueHigh.size)
      // console.log("axes top: ", uniqueTop.size)
      const maxAxes = Math.max(numYAxesYposBot, numYAxesYposHigh, numYAxesYposTop);
      let basePadding = 16;

      if (maxAxes > 1 && maxAxes % 2 == 0) {
        basePadding = -4;
      }
      if (maxAxes === 1) {
        axisPadding = 0;
      }

      let pad = basePadding + (maxAxes * axisPadding);

      if (maxAxes <= 1) pad += 34;
      return pad;
    },
    dynamicPaddingXRight() {
      // console.log("axesdata: ", this.axesData);
      let axisPadding = 40;
      
      const uniqueBottom = new Set();
      const uniqueHigh = new Set();
      const uniqueTop = new Set();
      
      if (this.axesData && this.axesData.array && this.axesData.array.length > 1) {
        for (let axis of this.axesData.array) {
          if (axis.rightSide && axis.visible) {
            if (axis.gi === this.$enum.graph_pos.graph_pos_bottom) {
              uniqueBottom.add(axis.unit);
            } else if (axis.gi === this.$enum.graph_pos.graph_pos_high) {
              uniqueHigh.add(axis.unit);
            } else {
              uniqueTop.add(axis.unit);
            }
          }
        }
      }
      
      const numYAxesYposBot = uniqueBottom.size;
      const numYAxesYposHigh = uniqueHigh.size;
      const numYAxesYposTop = uniqueTop.size;
      
      // console.log("axes bot: ", uniqueBottom.size)
      // console.log("axes high: ", uniqueHigh.size)
      // console.log("axes top: ", uniqueTop.size)
      const maxAxes = Math.max(numYAxesYposBot, numYAxesYposHigh, numYAxesYposTop);
      let basePadding = 34;
      
      if (maxAxes > 1 && maxAxes % 2 == 0) {
        basePadding = 15;
      }
      if (maxAxes < 3) {
        basePadding = 15
        // axisPadding = -160;
      }
      if (maxAxes < 1) {
        basePadding = 0
        // axisPadding = -160;
      }

      return basePadding + (maxAxes * axisPadding);
    },
    panelAxes() {
      const byUnit = new Map();
      for (const s of this.channel_series) {
        if (s.unit == null) continue;
        if (!byUnit.has(s.unit)) {
          byUnit.set(s.unit, { rep: s, all: [], allVisible: [] });
        }
        const entry = byUnit.get(s.unit);
        if (!entry.rep.yLabel && s.yLabel) entry.rep = s;
        entry.all.push(s);
        if (!this.is_hidden(s)) entry.allVisible.push(s);
      }
      const result = [];
      for (const [unit, { rep, allVisible }] of byUnit) {
        if (!allVisible.length) continue;
        const visRep = allVisible.find(s => s.yLabel) || allVisible[0];
        result.push({
          unit,
          yLabel: visRep.yLabel,
          yPos: visRep.yPos,
          grid: visRep.grid,
          zero_line: visRep.zero_line,
          draw_line_at: visRep.draw_line_at,
          draw_line_at_value: visRep.draw_line_at_value,
          graph_type: visRep.graph_type,
          override_y_axis_scale: visRep.override_y_axis_scale,
          graph_min: Math.min(...allVisible.map(s => s.graph_min ?? 0)),
          graph_max: Math.max(...allVisible.map(s => s.graph_max ?? 200)),
          override_y_axis_scale_min: Math.min(...allVisible.map(s => s.override_y_axis_scale_min ?? 0)),
          override_y_axis_scale_max: Math.max(...allVisible.map(s => s.override_y_axis_scale_max ?? 200)),
        });
      }
      return result;
    },
    bothArraysPopulated() {
      // Check if channel_series has data
      const channelOk = this.channel_series && this.channel_series.length > 0;

      // Check if diagram.diagramSettings.series has data
      const diagramOk =
        this.diagram && 
        this.diagram.diagramSettings &&
        this.diagram.diagramSettings.series &&
        this.diagram.diagramSettings.series.length > 0;

      // console.log('[bothArraysPopulated] channelOk=', channelOk, 'diagramOk=', diagramOk)
      return channelOk && diagramOk;
    },
    loading_data() {
      return this.is_loading_data;
    },
    get_series() {
      return this.series;
    },

    fill_channels_title() {
      return this.channel_series.length ? this.$txt.clear_channels : this.$txt.fill_channels;
    },
    // available_graph_settings() {
    //   console.log("graph_props: ", this.$app.graph_props)
    //   if (this.$app.graph_props == null) {
    //     return [];
    //   }
    //   else if ((this.zone == null) && (this.controller == null)) {
    //     // Project level. Neither controller nor zone selected
    //     return this.$app.graph_props.filter(s => (s.controllerId == null) && (s.zoneId == null));
    //   }
    //   else if (this.zone == null) {
    //       return this.$app.graph_props.filter(s => (s.controllerId == this.controller.id));
    //   }
    //   else {
    //     return this.$app.graph_props.filter(s => (s.zoneId == this.zone.id));              
    //   }
    // },
    available_graph_settings_user() {
      return this.available_graph_settings.filter(s => s.id <= 900000);
    },
    available_graph_settings() {
      const props = this.$app.graph_props || []
      let filtered
      
      if (!this.$app.graph_props) {
        filtered = []
      }
      else if (!this.zone && !this.controller) {
        filtered = props.filter(s => s.controllerId == null && s.zoneId == null)
      }
      else if (!this.zone) {
        filtered = props.filter(s => s.controllerId === this.controller.id)
      }
      else {
        filtered = props.filter(s => s.zoneId === this.zone.id)
      }
      // console.log("graph_props: ", filtered)
      if (filtered && filtered.length) {
        // console.log("first graph prop value: ", JSON.parse(filtered[0].value));
      }
      
      return [...globalSettings.available_graph_settings_presets, ...filtered]
    },
    any_graph_setting_selected() {
      if (this.selected_graph_setting == null)
        return false;
      else if (this.selected_graph_setting == "")
        return false;
      else
        return true;
    },
    formulaDefaultsChanged() {
      if (this.selected_graph_setting != 999996) return false;
      return this.channel_series.some(serie => {
        const nodeObj = this.getNodeType(serie.id);
        if (!nodeObj?.channel?.formula) return false;
        return serie.graph_min !== nodeObj.channel.formula.graphScaleMin ||
               serie.graph_max !== nodeObj.channel.formula.graphScaleMax;
      });
    },
    canvas_id() {
      return `${this.unique_identifier}_canvas`;
    },
    overview_range() {
      const base = this.end_date - this.start_date;
      const center = this.start_date + base / 2 + this.natural_offset_ms;
      const half = (base * this.natural_scaling_factor) / 2;
      return { from: center - half, to: center + half };
    },
    show_overview() {
      return this.overview_series != null &&
        !this.diagram &&
        !this.autoshift &&
        !this.disable_zoom &&
        this.overview_frame != null &&
        this.overview_range.to > this.overview_range.from;
    },
    select_deselect_message() {
      return this.$txt.show_all;
    }
  },
  watch: {
    // Re-sort the channel list + graph live when nodes (or zones/controllers) are
    // moved in the project tree, instead of only after a page refresh.
    tree_node_order_key() {
      this.sort_series_based_on_project_tree();
      this.resize();
    },
    hovered_channels() {
      this.$nextTick(() => {
        const el = this.$refs.hover_tooltip;
        if (el) this.tooltip_width = el.offsetWidth;
      });
    },
    interval_scaling_factor(newVal, oldVal) {
      if (newVal === oldVal || this.diagram?.diagramSettings?.localSettings?.selected_recording > -1 || this.blockWatcherEmits) return;
      this.emitDiagramSettings();
    },
    // offset_ms(newVal, oldVal) {
    //   if (newVal === oldVal || this.diagram?.diagramSettings?.localSettings?.selected_recording > -1 || this.blockWatcherEmits) return;
    //   this.emitDiagramSettings();
    // },
    series: {
      immediate: true,
      handler(val) {
        // Before replacing channel_series with fresh graphbuffer objects (e.g.
        // after graph_buffer.reset() on "Show graph" or a zoom that changes
        // resolution), snapshot the user-configured settings into temp_storage
        // so that default_settings() can restore them after the data reload.
        // Only in zone/live context (!this.diagram); reports restore via
        // load_graph_settings_from_saved_report_diagram instead.
        if (!this.diagram &&
            this.channel_series.length > 0 &&
            this.channel_series[0]?.settings_updated) {
          globalSettings.temp_storage_off_channel_series = this.channel_series.slice();
        }
        // If no setting was resolved at mount (empty localStorage + nodes not yet
        // loaded), retry the smart default now that we have real series/nodes.
        if (!this.diagram && !this.selected_graph_setting && val?.length > 0 &&
            localStorage.getItem("GlobalGraphPreset") == null &&
            this.has_operating_data_nodes()) {
          this.selected_graph_setting = 999998;
        }
        this.channel_series = (val || []).slice();
        this.sort_series_based_on_project_tree();
      }
    },
    // Whenever the summary changes, call resize.
    axesVisibilitySummary(newVal, oldVal) {
      this.resize();
    },
    bothArraysPopulated(newVal) {
      if (newVal && !this.hasDoneInitialLoad) {
        // only run once
        this.hasDoneInitialLoad = true;
        
        // call your method that merges diagram settings into channel_series
        this.load_graph_settings_from_saved_report_diagram();
      }
    },
    graph_buffer(newVal) {
      this.prev_hidden_series = [...(newVal?.hidden_series ?? [])];
      if (newVal && !newVal.on_all_data_loaded_callback) {
        newVal.on_all_data_loaded_callback = () => {
          if (this.selected_graph_setting == 999998) {
            this.$nextTick(() => this.default_operating_data_scaling_settings());
          }
          if (this.selected_graph_setting == 1000002) {
            this.$nextTick(() => this.default_decay_results_scaling_settings());
          }
        };
      }
    },
    'graph_buffer.hidden_series': function() {
      const newHidden = this.graph_buffer.hidden_series;
      const prev = this.prev_hidden_series;
      const newlyVisible = prev.filter(id => !newHidden.includes(id));
      if (newlyVisible.length) {
        const unitRefs = new Map();
        for (const s of this.channel_series) {
          if (s.unit == null) continue;
          if (prev.includes(s.id) || newlyVisible.includes(s.id)) continue;
          if (!unitRefs.has(s.unit)) unitRefs.set(s.unit, s);
        }
        for (const id of newlyVisible) {
          const s = this.channel_series.find(c => c.id === id);
          if (!s || s.unit == null) continue;
          const ref = unitRefs.get(s.unit);
          if (!ref) continue;
          s.yPos = ref.yPos;
          s.yLabel = ref.yLabel;
          s.grid = ref.grid;
          s.zero_line = ref.zero_line;
          s.draw_line_at = ref.draw_line_at;
          s.draw_line_at_value = ref.draw_line_at_value;
          s.override_y_axis_scale = ref.override_y_axis_scale;
          s.override_y_axis_scale_min = ref.override_y_axis_scale_min;
          s.override_y_axis_scale_max = ref.override_y_axis_scale_max;
          s.graph_min = ref.graph_min;
          s.graph_max = ref.graph_max;
        }
      }
      this.prev_hidden_series = [...newHidden];
      this.resize();
    },
    start_date() {
        this.on_selection_changed();
    },
    end_date() {
        this.on_selection_changed();
    },
    selected_graph_setting() {
      if (this.selected_graph_setting) {
        this.$app.settings.report.selected_graph_setting_prop = this.selected_graph_setting;
      }
      // Auto-set recording type to decay results only when user first selects
      // these presets — not on every data reload (which would override manual changes).
      if (this.selected_graph_setting == 999999 || this.selected_graph_setting == 1000002) {
        this.$app.settings.report.report_type = 7;
      }
      // Operating data presets: only nudge the recording-type filter when
      // the current type is decay-results (which would hide every operating
      // recording). Other choices (Monitor, LPR, etc.) the user explicitly
      // picked are left alone — they're compatible with operating data and
      // shouldn't be overridden.
      if ((this.selected_graph_setting == 999997 || this.selected_graph_setting == 999998)
          && this.$app.settings.report.report_type == Camur.report_type.reptype_decay_results) {
        this.$app.settings.report.report_type = Camur.report_type.reptype_all_recordings;
      }
      if (this.settings_loaded_from_report) {
        return;
      }
      else if (this.selected_graph_setting == null) {
        localStorage.setItem("GlobalGraphPreset", "");
      }
      else {
        if (this.channel_series.length > 0) {
          this.load_graph_settings(this.selected_graph_setting);
        }
        localStorage.setItem("GlobalGraphPreset", String(this.selected_graph_setting));
      }
    },
    use_custom_size() {
      if (!this.diagram) {
        localStorage.setItem('timegraph_custom_size', JSON.stringify({ use_custom_size: this.use_custom_size, custom_width: this.custom_width, custom_height: this.custom_height }));
      }
    },
    openGraphSettings(val) {
      // Persist for non-diagram contexts; diagram context has its own
      // per-instance flow and shouldn't write to the shared key.
      if (!this.diagram) {
        this.$appm.persist('graphSettingsPanel.open', val);
      }
    },
    custom_width() {
      if (!this.diagram) {
        localStorage.setItem('timegraph_custom_size', JSON.stringify({ use_custom_size: this.use_custom_size, custom_width: this.custom_width, custom_height: this.custom_height }));
      }
    },
    custom_height() {
      if (!this.diagram) {
        localStorage.setItem('timegraph_custom_size', JSON.stringify({ use_custom_size: this.use_custom_size, custom_width: this.custom_width, custom_height: this.custom_height }));
      }
    },
    selected_save_graph_settings_as() {
      this.save_graph_settings_as_name = this.getNameOfGraphProps(this.selected_save_graph_settings_as);
    },

    requested_zoom_interval: {
      immediate: true,
      handler() {
        if (this.requested_zoom_interval != null) {
          this.set_displayed_area_to_dates(this.requested_zoom_interval.from.getTime(), this.requested_zoom_interval.to.getTime());
          if (!this.requested_zoom_interval.preserve_view) {
            this.natural_scaling_factor = this.interval_scaling_factor;
            this.natural_offset_ms = this.offset_ms;
          }
          this.resize();
          this.on_displayed_area_changed(true);
        }
      },
    },
    graph_state() {
      this.resize();
      if (this.selected_graph_setting == 999998 &&
          !this.diagram &&
          this.channel_series.length > 0 &&
          this.channel_series[0]?.settings_updated) {
        const axisMax = {};
        const axisMin = {};
        for (const s of this.series) {
          if (!s.data?.length || !s.override_y_axis_scale || this.is_hidden(s)) continue;
          const yp = s.yPos;
          for (const pt of s.data) {
            if (!pt) continue;
            if (pt.maxVal > (axisMax[yp] ?? -Infinity)) axisMax[yp] = pt.maxVal;
            if (pt.minVal < (axisMin[yp] ?? Infinity)) axisMin[yp] = pt.minVal;
          }
        }
        for (const s of this.series) {
          if (!s.override_y_axis_scale) continue;
          const yp = s.yPos;
          if (axisMax[yp] != null && axisMax[yp] > 0)
            s.override_y_axis_scale_max = yp === 0
              ? Math.ceil(axisMax[yp] / 500) * 500
              : this.roundUpNice(axisMax[yp]);
          if (yp === 0 && axisMin[yp] != null && axisMin[yp] < 0)
            s.override_y_axis_scale_min = -Math.ceil(Math.abs(axisMin[yp]) / 500) * 500;
        }
      }
      if (this.selected_graph_setting == 1000002 &&
          !this.diagram &&
          this.channel_series.length > 0 &&
          this.channel_series[0]?.settings_updated) {
        let highestValue = 0;
        for (const s of this.series) {
          if (!s.data?.length || this.is_hidden(s)) continue;
          for (const pt of s.data) {
            const val = this.plotted_value(pt);
            if (val != null && val > highestValue) highestValue = val;
          }
        }
        if (highestValue > 0) {
          const scale = Math.max(Math.ceil(highestValue / 10) * 10 + 10, 100);
          for (const s of this.series) {
            if (!s.override_y_axis_scale) continue;
            s.override_y_axis_scale_max = scale;
            s.override_y_axis_scale_min = 0;
          }
        }
      }
    },
    show_channel_control_panel(val) {
      this.$nextTick(() => this.resize());
      if (!this.diagram) {
        this.$appm.persist('graphSettingsPanel.show_channel_control_panel', val);
      }
    },
    show_legend(val) {
      this.resize();
      if (!this.diagram) {
        this.$appm.persist('graphSettingsPanel.show_legend', val);
      }
    },
  }
};
</script>

<style lang="css" scoped>
/* .tg_select_channel_column {
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
} */
.tg_select_channel_column table {
  width: 100%;
  table-layout: fixed;
}
.tg_select_channel_column td {
  white-space: nowrap;
  overflow: visible;   /* Ensure text isn't clipped */
  /* text-overflow: ellipsis; */
}

.tg_timegraph_holder {
  position: relative;
}

.tg_toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  width: 100%;
}
.tg_toolbar_group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
}
.tg_toolbar_right {
  margin-left: auto;
}
.tg_toolbar_check {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.tg_preset_count_badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: #666;
  background: #e8e8e8;
  border-radius: 10px;
  padding: 1px 6px;
  margin-left: 4px;
  line-height: 28px;
  vertical-align: middle;
  pointer-events: none;
}

.tg_graph_settings_panel {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background: #fff;
  border-left: 2px solid #ccc;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tg_gsp_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: bold;
  font-size: 13px;
  flex-shrink: 0;
}

.tg_gsp_content {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.tg_gsp_drag_handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: ew-resize;
  background: transparent;
}

.tg_gsp_drag_handle:hover {
  background: rgba(0, 0, 0, 0.1);
}

.tg_gsp_slide-enter-active,
.tg_gsp_slide-leave-active {
  transition: max-width 0.2s ease, opacity 0.15s ease;
  max-width: 700px;
}

.tg_gsp_slide-enter-from,
.tg_gsp_slide-leave-to {
  max-width: 0 !important;
  opacity: 0;
}
</style>
